var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAuthArt(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 550,
    height: 550,
    viewBox: "0 0 550 550",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector_Object",
    "data-name": "Vector Object",
    transform: "translate(1.258 16.302)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ring",
    transform: "translate(-1.258 -16.302)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Oval",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3,
    strokeDasharray: "3 10",
    opacity: 0.76
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 275,
    cy: 275,
    r: 275,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 275,
    cy: 275,
    r: 273.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval-2",
    "data-name": "Oval",
    transform: "translate(26 26)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3,
    strokeDasharray: "3 10",
    opacity: 0.76
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 249,
    cy: 249,
    r: 249,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 249,
    cy: 249,
    r: 247.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval-3",
    "data-name": "Oval",
    transform: "translate(52 52)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3,
    strokeDasharray: "3 10",
    opacity: 0.76
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 223,
    cy: 223,
    r: 223,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 223,
    cy: 223,
    r: 221.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval-4",
    "data-name": "Oval",
    transform: "translate(80 80)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3,
    strokeDasharray: "3 10",
    opacity: 0.54
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 195,
    cy: 195,
    r: 195,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 195,
    cy: 195,
    r: 193.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11756",
    "data-name": "Group 11756",
    transform: "translate(32.514 59.835)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M131.042,304.428c0,8.981-13.689,16.262-30.575,16.262S69.9,313.41,69.9,304.428s13.688-16.263,30.572-16.263S131.042,295.446,131.042,304.428Z",
    transform: "translate(-24.253 6.098)",
    fill: "#9a7c88",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M378.953,239.4c0,10.693-16.3,19.362-36.4,19.362s-36.4-8.668-36.4-19.362,16.3-19.36,36.4-19.36S378.953,228.708,378.953,239.4Z",
    transform: "translate(37.763 -11.784)",
    fill: "#9a7c88",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 21.718,
    cy: 11.553,
    rx: 21.718,
    ry: 11.553,
    transform: "translate(329.909 387.206)",
    fill: "#9a7c88",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M420.054,209.692c0,8.433-12.853,15.27-28.706,15.27s-28.705-6.836-28.705-15.27,12.852-15.269,28.705-15.269S420.054,201.259,420.054,209.692Z",
    transform: "translate(52.589 -18.508)",
    fill: "#9a7c88",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M242.253,92.954c0,8.433-12.852,15.27-28.706,15.27s-28.705-6.836-28.705-15.27,12.852-15.269,28.705-15.269S242.253,84.521,242.253,92.954Z",
    transform: "translate(5.919 -49.15)",
    fill: "#9a7c88",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M264.956,70.353c0,8.432-12.852,15.269-28.706,15.269s-28.705-6.836-28.705-15.269,12.852-15.27,28.705-15.27S264.956,61.919,264.956,70.353Z",
    transform: "translate(11.878 -55.083)",
    fill: "#9a7c88",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M170.573,136.674,102.34,175.928,66.312,155.153l68.287-39.1Z",
    transform: "translate(-25.193 -39.08)",
    fill: "#9a7c88",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M279.234,373.569a63.385,63.385,0,0,0-9.577.721c-.677-3.761-4.938-6.961-10.945-8.632l22.07-12.7-35.973-20.623-68.288,39.1,36.029,20.774,19.258-11.08c3.165,2.685,8.454,4.58,14.621,5.025a10.885,10.885,0,0,0-1.762,5.8c0,10.154,15.477,18.387,34.568,18.387s34.568-8.233,34.568-18.387S298.326,373.569,279.234,373.569Z",
    transform: "translate(3.735 17.693)",
    fill: "#9a7c88",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M199.16,113.177l-35.585,20.639-29.26-17.029L169.954,96.3Z",
    transform: "translate(-7.344 -44.264)",
    fill: "#9a7c88",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M99.573,200.517,71.168,216.956,33.742,194.811,62.2,178.524Z",
    transform: "translate(-33.742 -22.681)",
    fill: "#9a7c88",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M422.669,283.795l-24.033,13.774a21.045,21.045,0,0,1-21.186-.146l-19.519-11.549a4.065,4.065,0,0,1,.059-7.032l34.582-19.682a6.008,6.008,0,0,1,6.016.043l24.14,14.208A6.005,6.005,0,0,1,422.669,283.795Z",
    transform: "translate(50.829 -1.722)",
    fill: "#9a7c88",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M403.747,223.045c20.226-11.678,17.666-32.265-5.69-45.75L370.8,160.859c-23.357-13.485-59.015-14.963-79.243-3.285L96.112,270.417c-20.228,11.677-17.667,32.265,5.689,45.749l18.627,10.888c23.356,13.485,67.642,20.513,87.869,8.835Z",
    transform: "translate(-20.953 -30.248)",
    fill: "#9a7c88",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M391.054,148.324c0,9.164-13.966,16.593-31.194,16.593s-31.192-7.428-31.192-16.593,13.966-16.593,31.192-16.593S391.054,139.161,391.054,148.324Z",
    transform: "translate(43.672 -34.964)",
    fill: "#9a7c88",
    opacity: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11761",
    "data-name": "Group 11761",
    transform: "translate(405.759 29.048)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11758",
    "data-name": "Group 11758",
    transform: "translate(2.887)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M340.892,136.624s-1.711,1.861-4,4.089c-2.115,2.063-2.77,2.656-4.733,4.573-1.146,1.119-.2,2.147,1.982,2.063a39.3,39.3,0,0,0,8.7-1.882,44.2,44.2,0,0,0,6.516-3.4,4.316,4.316,0,0,0,1.934-2.445v-3.442Z",
    transform: "translate(-331.671 -3.009)",
    fill: "#23203a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M360.66,140.146s-.4,3.526-.64,7.956.383,8.342,1.737,8.83,5.21.425,7.4-5.725a24.462,24.462,0,0,0,.885-12.117Z",
    transform: "translate(-324.244 -2.246)",
    fill: "#23203a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M371.467,95.368c.809-12.624-6.833-18.31-6.833-18.31.554-4.253-21.149-.17-21.149-.17s-2.254,24.738-4.039,36.78c-2.029,13.685-1.14,38.117-1.14,38.117s.255,2.976,5.353,2.955a17.255,17.255,0,0,0,6.928-1.958,2.658,2.658,0,0,0,1.468-3.257c-.543-1.448.776-2.694,0-5.254a28.091,28.091,0,0,1-1.471-7.594,93.98,93.98,0,0,1,.616-13.656l4.531-22.495s2.564,20.432,3.649,27.049c1.039,6.34,1.5,10.6,2.765,16.006.54,2.308,1.9,2.987,2.416,5.945.346,1.978-.341,3.478-.456,7-.1,2.921,7.144,4.015,11.677,1.749s4.636-3.668,3.641-4.8c-1.059-1.2-1.4-.7-.805-6.357s-2.708-14.117-6.165-21.9C371.968,115.276,371.094,101.166,371.467,95.368Z",
    transform: "translate(-329.981 -19.036)",
    fill: "#656c9a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M339.607,84.009c2.38-3.929,4.337-7.232,4.337-7.232.568-.674.245-2.1.817-2.877,2.179-2.5,2.846-14.149,2.846-14.149l4.012-12.232s-4.5-3.229-8.45,3.149c-3.762,6.078-8.45,23.789-8.45,23.789S337.854,84.67,339.607,84.009Z",
    transform: "translate(-330.872 -26.497)",
    fill: "#656c9a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M339.407,100.245c1.38,2.342,4.318,4.089,7.276,5.164,1.249-1.317,2.977-5.509,2.977-5.509a56.444,56.444,0,0,0,1.927,7.368,37.067,37.067,0,0,0,20.7-3.2c.718-5.217-1.767-18.973-1.924-21.559-.524-8.693,1.194-22.289.89-24.573-.51-3.823-9.174-7.961-9.174-7.961s-6.147-4.76-12.515-2.254c0,0-6.811,5.5-7.622,13.274-.4,3.859-.058,15.632-.024,24.155C341.924,86.253,339.56,98.489,339.407,100.245Z",
    transform: "translate(-329.641 -26.421)",
    fill: "#7d86b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M352.117,53.313s-2.592,3.881-2.458,5.821.282,12.866,0,16.535c-.15,1.954-1.136,8.231-1.223,13.714a43.106,43.106,0,0,1-.826,8.933s-.319-4.578-.391-6.886.861-12.2,1.12-14.875.134-15.835,0-17.422,2.147-6.113,2.147-6.113Z",
    transform: "translate(-327.591 -24.838)",
    fill: "#656c9a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11757",
    "data-name": "Group 11757",
    transform: "translate(16.352 2.132)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M349.452,48.574l-.327,4.757a5.5,5.5,0,0,0,.967,3.627c2.163-.674,8.945-4.835,8.945-4.835l-1.673-9.3Z",
    transform: "translate(-343.449 -29.646)",
    fill: "#ffad97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M359.466,35.348c-2.252-2.87-8.725-5.287-12.943.953-4.423,6.546-.244,17.247,3.631,16.622,2.17-.35,7.055-2.327,9.195-5.823C361.757,43.168,361.214,37.577,359.466,35.348Z",
    transform: "translate(-344.624 -32.386)",
    fill: "#ffc5b3"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M344.908,38.933c.9,1.434,2.3,3.115,5.9,3.3a14.34,14.34,0,0,0,5.284-.726l-.254,3.941a3.4,3.4,0,0,0,1.082-.149c.389-1.5,1.031-1.847,1.762-1.216.827.715.707,3.455.707,3.455a10.094,10.094,0,0,0,3.11-7.209c-.008-2.813-2.466-8.9-7.618-9.542s-8.822,2.054-10.08,4.805A3.633,3.633,0,0,0,344.908,38.933Z",
    transform: "translate(-328.317 -30.698)",
    fill: "#23203a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11760",
    "data-name": "Group 11760",
    transform: "translate(0 41.974)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M354.5,80.813a13.651,13.651,0,0,0-1.749,1.563c-.9.956-3.969,1.658-5.051,1.173s-3.484-4.367-3.546-5.313-.187-1.7,1.472-1.843c0-2.129,6.858-1.231,6.858-1.231S354.237,75.487,354.5,80.813Z",
    transform: "translate(-325.516 -61.05)",
    fill: "#ffc5b3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11759",
    "data-name": "Group 11759"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M340.473,83.335l13.07,7.654-11.089-18.8-13.07-7.654Z",
    transform: "translate(-329.385 -63.79)",
    fill: "#bf9b90"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M350.826,89.553l1.212-.744-11.088-18.8-1.213.744Z",
    transform: "translate(-326.667 -62.353)",
    fill: "#dfc4b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M329.385,64.688l1.213-.744,13.07,7.654-1.213.744Z",
    transform: "translate(-329.385 -63.945)",
    fill: "#efd9d0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M345.15,78.053l2.314-8.831a.647.647,0,1,1,1.252.328l-2.267,8.657A9.723,9.723,0,0,0,345.15,78.053Z",
    transform: "translate(-325.247 -62.687)",
    fill: "#ea6f53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M333.845,71.234c2.459-.622,3.656,3.145,4.753,5.789.982,2.367-1.6,2.914-4.363.614C331.38,75.264,331.014,71.953,333.845,71.234Z",
    transform: "translate(-328.725 -62.049)",
    fill: "#ffc5b3"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M375.024,70.7c-1.9-8.658-3.959-15.8-9.109-17.994-2.982-1.27-4.9,7.1-4.369,11.954.612,5.643,2.442,7.331,4.782,11.386-2.872.355-10.711,1.669-16.073,3.971,1.791,2.463,2.81,8.807,2.81,8.807s17.562-2.617,21.268-4.468C376.933,83.056,376.376,76.855,375.024,70.7Z",
    transform: "translate(-323.907 -24.955)",
    fill: "#656c9a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M358.1,46.991a6.463,6.463,0,0,1,2.189,1.808,15.523,15.523,0,0,1,1.35,2.416l-8.81,7.737-2.947-3.087Z",
    transform: "translate(-324.004 -26.421)",
    fill: "#656c9a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M349.685,49.409a23.225,23.225,0,0,0,.92,5.821l-3.372.882S346.423,51.086,349.685,49.409Z",
    transform: "translate(-324.723 -25.786)",
    fill: "#656c9a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11774",
    "data-name": "Group 11774",
    transform: "translate(166.197 92.589)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M139.631,95.889l22.216,12.77v21.5l-22.216-12.745Z",
    transform: "translate(-139.631 -77.126)",
    fill: "#ceafa3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M186.771,92.709l-29.543,16.784v21.5l29.543-16.759Z",
    transform: "translate(-135.012 -77.961)",
    fill: "#dfc4b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M159.576,112.628l23.139-13.146v10.762L159.576,123.37Z",
    transform: "translate(-134.396 -76.183)",
    fill: "#34324c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M160.74,117.492l20.3-11.532V107.7l-20.3,11.515Z",
    transform: "translate(-134.09 -74.483)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M139.631,95.963l15.761,8.915,6.455,3.761v3.328L139.631,99.316Z",
    transform: "translate(-139.631 -77.107)",
    fill: "#23203a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M186.771,92.786,157.228,109.57V112.8l29.543-16.759Z",
    transform: "translate(-135.012 -77.94)",
    fill: "#34324c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M190.048,94.7l-16.233-9.192L144.744,102.3l15.761,9.185Z",
    transform: "translate(-138.289 -79.852)",
    fill: "#44435e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M180.529,87.672l-29.543,16.784v1.959l29.543-16.759Z",
    transform: "translate(-136.65 -79.283)",
    fill: "#34324c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M174.043,93.8l-12.563,7.282v1.959l12.563-7.257Z",
    transform: "translate(-133.896 -77.674)",
    fill: "#34324c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M183.509,89.426l-14.808-8.4-29.07,16.791,14.336,8.392,8.191-4.654,5.056,2.922,12.622-7.315-4.943-2.842Z",
    transform: "translate(-139.631 -81.027)",
    fill: "#4f4f68"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11762",
    "data-name": "Group 11762",
    transform: "translate(41.871 11.534)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M172.8,93.8c0,.563.857,1.02,1.915,1.02s1.915-.457,1.915-1.02-.857-1.019-1.915-1.019S172.8,93.236,172.8,93.8Z",
    transform: "translate(-172.796 -89.476)",
    fill: "#ceafa3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6",
    "data-name": "Rectangle 6",
    width: 3.831,
    height: 0.475,
    transform: "translate(0 3.847)",
    fill: "#ceafa3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    d: "M172.8,93.422c0,.563.857,1.019,1.915,1.019s1.915-.456,1.915-1.019-.857-1.019-1.915-1.019S172.8,92.859,172.8,93.422Z",
    transform: "translate(-172.796 -89.575)",
    fill: "#dfc4b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M173.089,93.3c0,.456.694.824,1.552.824s1.552-.369,1.552-.824-.7-.826-1.552-.826S173.089,92.849,173.089,93.3Z",
    transform: "translate(-172.72 -89.555)",
    fill: "#ea6f53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M176.192,93.78l-.359-3.115h-2.384l-.359,3.115Z",
    transform: "translate(-172.72 -90.031)",
    fill: "#ea6f53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M173.374,90.8c0,.35.534.634,1.192.634s1.192-.284,1.192-.634-.534-.634-1.192-.634S173.374,90.447,173.374,90.8Z",
    transform: "translate(-172.645 -90.163)",
    fill: "#ff8f80"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11763",
    "data-name": "Group 11763",
    transform: "translate(20.034 24.183)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    d: "M155.5,103.818c0,.563.857,1.019,1.915,1.019s1.915-.456,1.915-1.019-.857-1.019-1.915-1.019S155.5,103.255,155.5,103.818Z",
    transform: "translate(-155.5 -99.495)",
    fill: "#ceafa3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7",
    "data-name": "Rectangle 7",
    width: 3.831,
    height: 0.475,
    transform: "translate(0 3.848)",
    fill: "#ceafa3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    d: "M155.5,103.442c0,.562.857,1.019,1.915,1.019s1.915-.457,1.915-1.019-.857-1.019-1.915-1.019S155.5,102.879,155.5,103.442Z",
    transform: "translate(-155.5 -99.594)",
    fill: "#dfc4b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M155.793,103.323c0,.456.694.826,1.55.826s1.552-.37,1.552-.826-.694-.824-1.552-.824S155.793,102.868,155.793,103.323Z",
    transform: "translate(-155.423 -99.574)",
    fill: "#34324c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M158.895,103.8l-.359-3.116h-2.384l-.359,3.116Z",
    transform: "translate(-155.423 -100.05)",
    fill: "#34324c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    d: "M156.077,100.816c0,.351.534.635,1.192.635s1.192-.284,1.192-.635-.533-.634-1.192-.634S156.077,100.466,156.077,100.816Z",
    transform: "translate(-155.348 -100.182)",
    fill: "#4f4f68"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    d: "M153.967,102.709v2.5l-14.336-8.475v-2.4Z",
    transform: "translate(-139.631 -77.536)",
    fill: "#23203a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    "data-name": "Path 72",
    d: "M157.475,97.288v1.957l5.056,2.882V100.21Z",
    transform: "translate(-134.947 -76.759)",
    fill: "#23203a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    "data-name": "Path 73",
    d: "M162.6,100.374l10.352-6.016-4.061-2.344-10.352,6.016Z",
    transform: "translate(-134.669 -78.143)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    "data-name": "Path 74",
    d: "M142.476,95.791l6.133-3.564-1.2-.667-6.133,3.564Z",
    transform: "translate(-139.2 -78.262)",
    fill: "#ff8f80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    "data-name": "Path 75",
    d: "M144.379,96.891l6.133-3.564-1.2-.667-6.133,3.564Z",
    transform: "translate(-138.701 -77.973)",
    fill: "#ff8f80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    d: "M145.743,101.4l29.036-16.9-1.212-.705-29.036,16.9Z",
    transform: "translate(-138.345 -80.301)",
    fill: "#34324c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11765",
    "data-name": "Group 11765",
    transform: "translate(34.211 6.468)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    "data-name": "Path 77",
    d: "M166.729,88.136c0,.653.994,1.182,2.219,1.182s2.221-.529,2.221-1.182-.994-1.18-2.221-1.18S166.729,87.485,166.729,88.136Z",
    transform: "translate(-166.729 -85.938)",
    fill: "#ceafa3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8",
    "data-name": "Rectangle 8",
    width: 4.434,
    height: 0.951,
    transform: "translate(0.006 1.248)",
    fill: "#ceafa3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    "data-name": "Path 78",
    d: "M166.729,87.33c0,.653.994,1.182,2.219,1.182s2.221-.529,2.221-1.182-.994-1.18-2.221-1.18S166.729,86.679,166.729,87.33Z",
    transform: "translate(-166.729 -86.15)",
    fill: "#efd9d0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11764",
    "data-name": "Group 11764",
    transform: "translate(0.389 0.207)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    "data-name": "Path 79",
    d: "M168.868,86.521c-.943,0-1.712.383-1.81.871a.593.593,0,0,1-.02-.1c0-.538.821-.973,1.831-.973s1.831.436,1.831.973a.587.587,0,0,1-.019.1C170.581,86.9,169.812,86.521,168.868,86.521Z",
    transform: "translate(-167.037 -86.314)",
    fill: "#ceafa3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    "data-name": "Path 80",
    d: "M168.863,88.219c-.943,0-1.712-.383-1.81-.87.1-.489.867-.871,1.81-.871s1.713.383,1.812.871C170.577,87.836,169.808,88.219,168.863,88.219Z",
    transform: "translate(-167.033 -86.271)",
    fill: "#bc9c91"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11767",
    "data-name": "Group 11767",
    transform: "translate(29.107 9.422)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    "data-name": "Path 81",
    d: "M162.686,90.478c0,.651.995,1.18,2.221,1.18s2.219-.529,2.219-1.18-.994-1.182-2.219-1.182S162.686,89.825,162.686,90.478Z",
    transform: "translate(-162.686 -88.278)",
    fill: "#ceafa3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9",
    "data-name": "Rectangle 9",
    width: 4.434,
    height: 0.951,
    transform: "translate(0.006 1.248)",
    fill: "#ceafa3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82",
    "data-name": "Path 82",
    d: "M162.686,89.672c0,.651.995,1.18,2.221,1.18s2.219-.529,2.219-1.18-.994-1.182-2.219-1.182S162.686,89.019,162.686,89.672Z",
    transform: "translate(-162.686 -88.49)",
    fill: "#efd9d0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11766",
    "data-name": "Group 11766",
    transform: "translate(0.39 0.207)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    "data-name": "Path 83",
    d: "M164.826,88.862c-.944,0-1.713.381-1.812.87a.6.6,0,0,1-.019-.1c0-.538.819-.975,1.831-.975s1.831.437,1.831.975a.5.5,0,0,1-.02.1C166.538,89.244,165.77,88.862,164.826,88.862Z",
    transform: "translate(-162.995 -88.654)",
    fill: "#ceafa3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    "data-name": "Path 84",
    d: "M164.822,90.559c-.944,0-1.713-.381-1.812-.87.1-.489.867-.87,1.812-.87s1.712.381,1.81.87C166.534,90.177,165.766,90.559,164.822,90.559Z",
    transform: "translate(-162.991 -88.611)",
    fill: "#bc9c91"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11769",
    "data-name": "Group 11769",
    transform: "translate(23.81 12.522)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    "data-name": "Path 85",
    d: "M158.491,92.932c0,.653.994,1.182,2.219,1.182s2.221-.529,2.221-1.182-.994-1.18-2.221-1.18S158.491,92.281,158.491,92.932Z",
    transform: "translate(-158.491 -90.734)",
    fill: "#ceafa3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10",
    "data-name": "Rectangle 10",
    width: 4.434,
    height: 0.951,
    transform: "translate(0.006 1.248)",
    fill: "#ceafa3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    cx: 2.22,
    cy: 1.181,
    rx: 2.22,
    ry: 1.181,
    fill: "#efd9d0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11768",
    "data-name": "Group 11768",
    transform: "translate(0.389 0.207)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    d: "M160.63,91.317c-.944,0-1.712.383-1.81.87a.485.485,0,0,1-.02-.1c0-.538.821-.973,1.831-.973s1.831.436,1.831.973a.577.577,0,0,1-.019.1C162.343,91.7,161.574,91.317,160.63,91.317Z",
    transform: "translate(-158.799 -91.11)",
    fill: "#ceafa3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    "data-name": "Path 87",
    d: "M160.625,93.015c-.944,0-1.712-.383-1.81-.871.1-.487.866-.87,1.81-.87s1.713.383,1.812.87C162.339,92.632,161.57,93.015,160.625,93.015Z",
    transform: "translate(-158.795 -91.067)",
    fill: "#bc9c91"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11771",
    "data-name": "Group 11771",
    transform: "translate(18.706 15.477)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    "data-name": "Path 88",
    d: "M154.448,95.274c0,.651.995,1.18,2.221,1.18s2.219-.529,2.219-1.18-.994-1.182-2.219-1.182S154.448,94.621,154.448,95.274Z",
    transform: "translate(-154.448 -93.074)",
    fill: "#ceafa3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11",
    "data-name": "Rectangle 11",
    width: 4.434,
    height: 0.951,
    transform: "translate(0.006 1.248)",
    fill: "#ceafa3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    "data-name": "Path 89",
    d: "M154.448,94.468c0,.651.995,1.18,2.221,1.18s2.219-.529,2.219-1.18-.994-1.182-2.219-1.182S154.448,93.815,154.448,94.468Z",
    transform: "translate(-154.448 -93.286)",
    fill: "#efd9d0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11770",
    "data-name": "Group 11770",
    transform: "translate(0.39 0.207)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    "data-name": "Path 90",
    d: "M156.588,93.657c-.944,0-1.713.383-1.812.871a.6.6,0,0,1-.019-.1c0-.538.819-.975,1.831-.975s1.831.437,1.831.975a.5.5,0,0,1-.02.1C158.3,94.04,157.532,93.657,156.588,93.657Z",
    transform: "translate(-154.757 -93.45)",
    fill: "#ceafa3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    "data-name": "Path 91",
    d: "M156.584,95.355c-.944,0-1.713-.381-1.812-.87.1-.489.867-.871,1.812-.871s1.712.383,1.81.871C158.3,94.974,157.528,95.355,156.584,95.355Z",
    transform: "translate(-154.753 -93.407)",
    fill: "#bc9c91"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11773",
    "data-name": "Group 11773",
    transform: "translate(13.053 18.642)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    "data-name": "Path 92",
    d: "M149.97,97.779c0,.653.994,1.182,2.219,1.182s2.221-.529,2.221-1.182-.995-1.18-2.221-1.18S149.97,97.128,149.97,97.779Z",
    transform: "translate(-149.97 -95.581)",
    fill: "#ceafa3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12",
    "data-name": "Rectangle 12",
    width: 4.434,
    height: 0.951,
    transform: "translate(0.005 1.248)",
    fill: "#ceafa3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    d: "M149.97,96.975c0,.651.994,1.18,2.219,1.18s2.221-.529,2.221-1.18-.995-1.182-2.221-1.182S149.97,96.322,149.97,96.975Z",
    transform: "translate(-149.97 -95.793)",
    fill: "#efd9d0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11772",
    "data-name": "Group 11772",
    transform: "translate(0.389 0.207)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    "data-name": "Path 94",
    d: "M152.109,96.164c-.944,0-1.712.383-1.81.871a.5.5,0,0,1-.02-.1c0-.538.819-.975,1.831-.975s1.831.437,1.831.975a.594.594,0,0,1-.019.1C153.822,96.547,153.053,96.164,152.109,96.164Z",
    transform: "translate(-150.278 -95.957)",
    fill: "#ceafa3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    d: "M152.1,97.862c-.944,0-1.712-.383-1.81-.87.1-.489.866-.871,1.81-.871s1.713.383,1.812.871C153.818,97.479,153.049,97.862,152.1,97.862Z",
    transform: "translate(-150.274 -95.914)",
    fill: "#bc9c91"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11790",
    "data-name": "Group 11790",
    transform: "translate(78.81 32.323)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11780",
    "data-name": "Group 11780",
    transform: "translate(0 32.924)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    "data-name": "Path 96",
    d: "M139.122,79.987l7.137-4.119a2.1,2.1,0,0,0,1.227-1.683c0-.824-.691-1.694-1.891-2.387l-11.388-6.575a10.076,10.076,0,0,0-4.88-1.2,7.467,7.467,0,0,0-3.64.819l-3.454,1.995c-.485-.28-.966-.567-1.439-.866l4.159-2.4c2.57-1.483,7.05-1.313,9.989.384l11.388,6.575c1.669.963,2.623,2.3,2.626,3.659a3.46,3.46,0,0,1-1.962,2.957l-6.724,3.881C139.883,80.681,139.5,80.338,139.122,79.987Z",
    transform: "translate(-57.189 -58.533)",
    fill: "#34324c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11775",
    "data-name": "Group 11775",
    transform: "translate(25.284 114.008)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    d: "M92.554,153.757a7.908,7.908,0,0,0,3.3,6.309c1.823,1.053,3.3-.064,3.3-2.5a7.908,7.908,0,0,0-3.3-6.309C94.032,150.208,92.554,151.326,92.554,153.757Z",
    transform: "translate(-89.885 -149.362)",
    fill: "#23203a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98",
    "data-name": "Path 98",
    d: "M91.564,152.474l2.548-1.5,4.155,9.236-2.653,1.529Z",
    transform: "translate(-90.145 -149.332)",
    fill: "#23203a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_99",
    "data-name": "Path 99",
    d: "M90.44,154.978a7.908,7.908,0,0,0,3.3,6.309c1.824,1.053,3.3-.064,3.3-2.5a7.906,7.906,0,0,0-3.3-6.309C91.918,151.43,90.44,152.547,90.44,154.978Z",
    transform: "translate(-90.44 -149.042)",
    fill: "#34324c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_100",
    "data-name": "Path 100",
    d: "M91.564,155.43a3.984,3.984,0,0,0,1.663,3.176c.918.53,1.663-.033,1.663-1.257a3.984,3.984,0,0,0-1.663-3.176C92.309,153.642,91.564,154.205,91.564,155.43Z",
    transform: "translate(-90.145 -148.546)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101",
    "data-name": "Path 101",
    d: "M96.881,151.684v5.436a21.628,21.628,0,0,1-2.78,1.154c-1.494.491-2.1-.876-1.624-2.7a55.423,55.423,0,0,1,1.821-5.388Z",
    transform: "translate(-89.947 -149.541)",
    fill: "#ceafa3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102",
    "data-name": "Path 102",
    d: "M95.933,151.689l2.69-1.527V155.6l-2.69,1.53Z",
    transform: "translate(-88.998 -149.547)",
    fill: "#dfc4b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103",
    "data-name": "Path 103",
    d: "M98.562,149.7l-2.093,1.208-2.093-1.231-.49.643,2.583,1.5,2.69-1.527Z",
    transform: "translate(-89.535 -149.675)",
    fill: "#efd9d0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11776",
    "data-name": "Group 11776",
    transform: "translate(81.143 81.87)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_104",
    "data-name": "Path 104",
    d: "M136.8,128.3a7.908,7.908,0,0,0,3.3,6.309c1.824,1.053,3.3-.064,3.3-2.5a7.908,7.908,0,0,0-3.3-6.31C138.277,124.753,136.8,125.87,136.8,128.3Z",
    transform: "translate(-134.13 -123.906)",
    fill: "#23203a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_105",
    "data-name": "Path 105",
    d: "M135.809,127.018l2.548-1.5,4.155,9.236-2.654,1.529Z",
    transform: "translate(-134.39 -123.876)",
    fill: "#23203a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_106",
    "data-name": "Path 106",
    d: "M134.685,129.523a7.906,7.906,0,0,0,3.3,6.309c1.823,1.053,3.3-.064,3.3-2.5a7.911,7.911,0,0,0-3.3-6.31C136.163,125.972,134.685,127.091,134.685,129.523Z",
    transform: "translate(-134.685 -123.585)",
    fill: "#34324c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107",
    "data-name": "Path 107",
    d: "M135.809,129.973a3.984,3.984,0,0,0,1.663,3.178c.919.53,1.663-.033,1.663-1.257a3.979,3.979,0,0,0-1.663-3.176C136.554,128.186,135.809,128.749,135.809,129.973Z",
    transform: "translate(-134.39 -123.09)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    "data-name": "Path 108",
    d: "M141.126,126.227v5.438a21.541,21.541,0,0,1-2.78,1.154c-1.493.49-2.1-.876-1.624-2.7a55.738,55.738,0,0,1,1.821-5.39Z",
    transform: "translate(-134.192 -124.085)",
    fill: "#ceafa3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    "data-name": "Path 109",
    d: "M140.178,126.233l2.69-1.527v5.433l-2.69,1.53Z",
    transform: "translate(-133.243 -124.09)",
    fill: "#dfc4b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    "data-name": "Path 110",
    d: "M142.808,124.241l-2.093,1.208-2.093-1.231-.49.643,2.583,1.5,2.69-1.527Z",
    transform: "translate(-133.78 -124.218)",
    fill: "#efd9d0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11777",
    "data-name": "Group 11777",
    transform: "translate(0 99.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_111",
    "data-name": "Path 111",
    d: "M72.527,142.023a7.911,7.911,0,0,0,3.3,6.31c1.824,1.053,3.3-.066,3.3-2.5a7.908,7.908,0,0,0-3.3-6.309C74.005,138.474,72.527,139.592,72.527,142.023Z",
    transform: "translate(-69.858 -137.628)",
    fill: "#23203a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_112",
    "data-name": "Path 112",
    d: "M71.537,140.74l2.548-1.5,4.155,9.236-2.653,1.529Z",
    transform: "translate(-70.118 -137.598)",
    fill: "#23203a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113",
    "data-name": "Path 113",
    d: "M70.413,143.244a7.908,7.908,0,0,0,3.3,6.31c1.823,1.053,3.3-.066,3.3-2.5a7.908,7.908,0,0,0-3.3-6.309C71.891,139.7,70.413,140.813,70.413,143.244Z",
    transform: "translate(-70.413 -137.308)",
    fill: "#34324c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114",
    "data-name": "Path 114",
    d: "M71.537,143.7a3.98,3.98,0,0,0,1.664,3.176c.918.53,1.663-.032,1.663-1.256a3.984,3.984,0,0,0-1.663-3.178C72.282,141.908,71.537,142.471,71.537,143.7Z",
    transform: "translate(-70.118 -136.813)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    d: "M76.854,139.95v5.436a21.541,21.541,0,0,1-2.78,1.154c-1.494.491-2.1-.875-1.624-2.7a55.8,55.8,0,0,1,1.821-5.388Z",
    transform: "translate(-69.919 -137.807)",
    fill: "#ceafa3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    "data-name": "Path 116",
    d: "M75.906,139.956l2.691-1.527v5.433l-2.691,1.53Z",
    transform: "translate(-68.971 -137.813)",
    fill: "#dfc4b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117",
    "data-name": "Path 117",
    d: "M78.536,137.964l-2.093,1.208-2.093-1.231-.49.643,2.583,1.5,2.691-1.527Z",
    transform: "translate(-69.508 -137.941)",
    fill: "#efd9d0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11778",
    "data-name": "Group 11778",
    transform: "translate(4.972)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_118",
    "data-name": "Path 118",
    d: "M74.351,85.262l27.934,16.107v66.748L74.351,152.055Z",
    transform: "translate(-74.351 -52.573)",
    fill: "#656c9a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119",
    "data-name": "Path 119",
    d: "M153.371,72.035,96.477,104.841v66.748l56.894-32.716Z",
    transform: "translate(-68.543 -56.045)",
    fill: "#7d86b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120",
    "data-name": "Path 120",
    d: "M97.534,105.354,151.815,74.2V80.67L97.534,111.746Z",
    transform: "translate(-68.266 -55.478)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_121",
    "data-name": "Path 121",
    d: "M96.477,112.727l56.894-32.8v1.724L96.477,114.369Z",
    transform: "translate(-68.543 -53.975)",
    fill: "#656c9a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122",
    "data-name": "Path 122",
    d: "M110.659,95.433l24.4-14.072v2.193l-24.4,14.033Z",
    transform: "translate(-64.821 -53.597)",
    fill: "#34324c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123",
    "data-name": "Path 123",
    d: "M97.534,114.661,151.815,83.5v6.472L97.534,121.053Z",
    transform: "translate(-68.266 -53.035)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124",
    "data-name": "Path 124",
    d: "M96.477,122.034l56.894-32.8v1.724L96.477,123.677Z",
    transform: "translate(-68.543 -51.532)",
    fill: "#656c9a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_125",
    "data-name": "Path 125",
    d: "M110.659,104.74l24.4-14.072v2.193l-24.4,14.033Z",
    transform: "translate(-64.821 -51.154)",
    fill: "#34324c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_126",
    "data-name": "Path 126",
    d: "M97.534,123.866,151.815,92.71v6.472L97.534,130.258Z",
    transform: "translate(-68.266 -50.618)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_127",
    "data-name": "Path 127",
    d: "M96.477,131.239l56.894-32.8v1.724L96.477,132.882Z",
    transform: "translate(-68.543 -49.116)",
    fill: "#656c9a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_128",
    "data-name": "Path 128",
    d: "M110.659,113.945l24.4-14.072v2.193l-24.4,14.033Z",
    transform: "translate(-64.821 -48.738)",
    fill: "#34324c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_129",
    "data-name": "Path 129",
    d: "M97.534,133.276l54.282-31.156v10.927L97.534,144.122Z",
    transform: "translate(-68.266 -48.149)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_130",
    "data-name": "Path 130",
    d: "M110.659,123.355l24.4-14.072v2.193l-24.4,14.033Z",
    transform: "translate(-64.821 -46.268)",
    fill: "#34324c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_131",
    "data-name": "Path 131",
    d: "M96.477,144.881l56.894-32.8V113.8L96.477,146.524Z",
    transform: "translate(-68.543 -45.535)",
    fill: "#656c9a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_132",
    "data-name": "Path 132",
    d: "M97.534,146.791l54.282-31.156v10.927L97.534,157.638Z",
    transform: "translate(-68.266 -44.601)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_133",
    "data-name": "Path 133",
    d: "M110.659,136.871l24.4-14.072v2.193l-24.4,14.033Z",
    transform: "translate(-64.821 -42.721)",
    fill: "#34324c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134",
    "data-name": "Path 134",
    d: "M159.178,75.359l-56.894,32.806L74.351,92.058,131.287,59.37Z",
    transform: "translate(-74.351 -59.37)",
    fill: "#a6acc6"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_135",
    "data-name": "Path 135",
    d: "M96.477,157.832,154.339,124.5v1.736L96.477,159.567Z",
    transform: "translate(-63.572 -42.275)",
    fill: "#dfc4b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_136",
    "data-name": "Path 136",
    d: "M96.477,156.858l56.894-32.8.968.559L96.477,157.976Z",
    transform: "translate(-63.572 -42.391)",
    fill: "#efd9d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137",
    "data-name": "Path 137",
    d: "M102.486,154.362l-28.9-16.646v1.736l28.9,16.646Z",
    transform: "translate(-69.581 -38.805)",
    fill: "#ceafa3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138",
    "data-name": "Path 138",
    d: "M75.482,89.229,99.9,103.292v2.843L75.482,92.072Z",
    transform: "translate(-69.082 -51.532)",
    fill: "#dfc4b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_139",
    "data-name": "Path 139",
    d: "M102.486,153.388,74.552,137.273l-.968.559,28.9,16.674Z",
    transform: "translate(-69.581 -38.921)",
    fill: "#efd9d0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11779",
    "data-name": "Group 11779",
    transform: "translate(3.354 39.428)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_140",
    "data-name": "Path 140",
    d: "M75.026,92.211l2.7-1.577.61,1.332L75.758,93.48a2.092,2.092,0,0,0-1.223,1.677c0,.822.688,1.689,1.885,2.381l11.352,6.552c2.481,1.433,6.371,1.607,8.491.383l2.477-1.446.654,1.309L97,105.741a8.912,8.912,0,0,1-4.371,1.006,11.475,11.475,0,0,1-5.585-1.389L75.687,98.806c-1.663-.961-2.616-2.29-2.617-3.649A3.448,3.448,0,0,1,75.026,92.211Z",
    transform: "translate(-73.07 -90.592)",
    fill: "#34324c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_141",
    "data-name": "Path 141",
    d: "M93.294,100.828a1.148,1.148,0,0,0,.48.917c.264.153.48-.009.48-.362a1.151,1.151,0,0,0-.48-.917C93.509,100.313,93.294,100.476,93.294,100.828Z",
    transform: "translate(-67.761 -88.026)",
    fill: "#34324c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_142",
    "data-name": "Path 142",
    d: "M76.636,91.02a1.15,1.15,0,0,0,.478.915c.265.153.48-.009.48-.362a1.147,1.147,0,0,0-.48-.915C76.851,90.505,76.636,90.667,76.636,91.02Z",
    transform: "translate(-72.134 -90.6)",
    fill: "#34324c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11787",
    "data-name": "Group 11787",
    transform: "translate(28.652 54.322)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11783",
    "data-name": "Group 11783",
    transform: "translate(0.008 0.357)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11781",
    "data-name": "Group 11781",
    transform: "translate(0 2.202)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_143",
    "data-name": "Path 143",
    d: "M93.271,91.067a2.729,2.729,0,0,1,.3-.495c1.006-1.319,2.757-1.437,4.258-1.365a4.278,4.278,0,0,0,2.8-.5c1.331-.774,16.1-9.33,17.773-10.36l3.131,1.808C118.85,81.675,103.92,90.3,103.755,90.4c-.513.33-.376.858-.266,1.266a2.2,2.2,0,0,1-1.088,2.488,4.9,4.9,0,0,1-3.776.821.741.741,0,0,1,.111-.218c.273-.34.915-1.159,1.245-1.592.254-.335-.6-.922-1.776-1.278-1.381-.419-2.049-.4-2.351-.151a13.816,13.816,0,0,0-1.579,1.66,1.949,1.949,0,0,1-.172.163v-.875Z",
    transform: "translate(-93.073 -78.346)",
    fill: "#bf9c91"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_144",
    "data-name": "Path 144",
    d: "M93.312,88.422l.831,1.619v.875A1.978,1.978,0,0,1,93.312,88.422Z",
    transform: "translate(-93.114 -75.701)",
    fill: "#ad887f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13",
    "data-name": "Rectangle 13",
    width: 1.107,
    height: 0.849,
    transform: "translate(0.001 12.702)",
    fill: "#ad887f"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_145",
    "data-name": "Path 145",
    d: "M117.954,77.626a2.524,2.524,0,0,0-1.895-1.024,4.679,4.679,0,0,0-2.27.64l3.709.65Z",
    transform: "translate(-87.687 -76.602)",
    fill: "#bf9c91"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11782",
    "data-name": "Group 11782",
    transform: "translate(25.049 0.307)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_146",
    "data-name": "Path 146",
    d: "M113.7,77.439a3.669,3.669,0,0,1,1.636-.418v.664l-.006-.01a2.557,2.557,0,0,0-.367.078v-.591l-.664.066V78.1a.779.779,0,0,0-.189.278c.254.045.441.141.452.244s-.182.192-.456.208a1.1,1.1,0,0,0,.353.479.817.817,0,0,1,.641-.008c.143.086.124.234-.029.361a3.256,3.256,0,0,0,.769.2.333.333,0,0,1,.366-.285.512.512,0,0,1,.439.293,2.5,2.5,0,0,0,.5-.109c-.168-.134-.217-.275-.1-.347a.833.833,0,0,1,.638.052.792.792,0,0,0,.225-.324c-.283-.042-.5-.143-.509-.254s.2-.2.494-.211a1.146,1.146,0,0,0-.34-.444V77.4a3.975,3.975,0,0,1,.448.217c1.273.735,1.41,1.846.308,2.482a4.776,4.776,0,0,1-4.3-.178C112.735,79.187,112.6,78.076,113.7,77.439Z",
    transform: "translate(-112.955 -76.799)",
    fill: "#bf9c91"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_147",
    "data-name": "Path 147",
    d: "M116.147,77.828a3.249,3.249,0,0,0-.691-.159v-.627a5.108,5.108,0,0,1,1.241.28l-.256.331Z",
    transform: "translate(-112.298 -76.794)",
    fill: "#bf9c91"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_148",
    "data-name": "Path 148",
    d: "M116.554,77.28l-.548-.082s0,.773,0,.841a.171.171,0,0,0,.1.158.82.82,0,0,0,.653-.013v-.875Z",
    transform: "translate(-112.155 -76.752)",
    fill: "#ad887f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_149",
    "data-name": "Path 149",
    d: "M114.62,78.111a.8.8,0,0,1-.6-.038V77.2l.664-.066v.891A.109.109,0,0,1,114.62,78.111Z",
    transform: "translate(-112.676 -76.769)",
    fill: "#ad887f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_150",
    "data-name": "Path 150",
    d: "M114.84,77.067v-.222h.778v.247A5.027,5.027,0,0,0,114.84,77.067Z",
    transform: "translate(-112.46 -76.845)",
    fill: "#ad887f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_151",
    "data-name": "Path 151",
    d: "M115.257,77.937a.517.517,0,0,1-.417-.251v-.664a5.025,5.025,0,0,1,.778.025v.627A.334.334,0,0,1,115.257,77.937Z",
    transform: "translate(-112.46 -76.8)",
    fill: "#ad887f"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14",
    "data-name": "Rectangle 14",
    width: 1.629,
    height: 0.654,
    transform: "translate(27.918 2.914)",
    fill: "#bf9c91"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_152",
    "data-name": "Path 152",
    d: "M114.346,77.618v.766s-.379.032-.48-.237a1.349,1.349,0,0,1-.1-.427Z",
    transform: "translate(-87.693 -76.335)",
    fill: "#ad887f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15",
    "data-name": "Rectangle 15",
    width: 0.817,
    height: 0.801,
    transform: "translate(30.33 1.65)",
    fill: "#bf9c91"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_153",
    "data-name": "Path 153",
    d: "M114.782,78.242v.381l-.259-.138Z",
    transform: "translate(-87.494 -76.171)",
    fill: "#ad887f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16",
    "data-name": "Rectangle 16",
    width: 0.939,
    height: 0.815,
    transform: "translate(9.559 15.267)",
    fill: "#bf9c91"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_154",
    "data-name": "Path 154",
    d: "M116.474,77.805v.716l.442.129.252-.552Z",
    transform: "translate(-86.983 -76.286)",
    fill: "#ad887f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_155",
    "data-name": "Path 155",
    d: "M116.146,78.3v.716l.442.129.252-.552Z",
    transform: "translate(-87.068 -76.154)",
    fill: "#ad887f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_156",
    "data-name": "Path 156",
    d: "M97.511,90.855v.875a2.293,2.293,0,0,0,1.164-.177,2.65,2.65,0,0,0,.572-.838Z",
    transform: "translate(-91.96 -72.897)",
    fill: "#bf9c91"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11786",
    "data-name": "Group 11786"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11784",
    "data-name": "Group 11784",
    transform: "translate(0 1.684)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_157",
    "data-name": "Path 157",
    d: "M100.675,88.013c1.331-.774,16.1-9.33,17.773-10.36l3.131,1.808C118.893,80.982,103.963,89.6,103.8,89.708c-.513.33-.376.858-.266,1.266a2.2,2.2,0,0,1-1.088,2.488,4.9,4.9,0,0,1-3.776.821.741.741,0,0,1,.111-.218,3.466,3.466,0,0,0,2.346-.314c1.228-.684,1.971-1.507,1.731-2.4-.29-1.072-1.39-1.985-3.434-2.362-1.38-.255-3.531-.441-4.593.341-1.434,1.055-1.741,2.16-.511,3.372a1.949,1.949,0,0,1-.172.163,1.955,1.955,0,0,1-.53-2.988c1.006-1.319,2.757-1.437,4.258-1.365A4.279,4.279,0,0,0,100.675,88.013Z",
    transform: "translate(-93.108 -77.653)",
    fill: "#dfc4b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_158",
    "data-name": "Path 158",
    d: "M94.736,87.021c1.062-.781,3.213-.6,4.593-.341,2.044.377,3.144,1.29,3.434,2.362.24.89-.5,1.713-1.731,2.4a3.466,3.466,0,0,1-2.346.314c.273-.34.915-1.159,1.245-1.592.254-.335-.6-.923-1.776-1.278-1.381-.419-2.049-.4-2.351-.151a13.816,13.816,0,0,0-1.579,1.66C92.995,89.181,93.3,88.076,94.736,87.021Z",
    transform: "translate(-93.016 -75.341)",
    fill: "#efd9d0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_159",
    "data-name": "Path 159",
    d: "M114.922,79.719a1.978,1.978,0,0,0-1.785-.063l-12.054,7.093c-.452.268-.385.73.149,1.031h0a1.975,1.975,0,0,0,1.784.063l12.054-7.093c.452-.268.385-.73-.148-1.031Z",
    transform: "translate(-91.094 -75.491)",
    fill: "#efd9d0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11785",
    "data-name": "Group 11785",
    transform: "translate(25.056)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_160",
    "data-name": "Path 160",
    d: "M114.008,79.232c-1.273-.735-1.411-1.847-.309-2.483a4.782,4.782,0,0,1,4.3.179c1.273.735,1.41,1.846.308,2.482A4.779,4.779,0,0,1,114.008,79.232Zm3.544-1.692a.82.82,0,0,1-.653.013c-.146-.087-.124-.24.037-.369a3.259,3.259,0,0,0-.823-.2.334.334,0,0,1-.361.263.517.517,0,0,1-.423-.261,2.41,2.41,0,0,0-.524.125c.162.133.208.27.095.341a.8.8,0,0,1-.6-.038.786.786,0,0,0-.189.276c.254.047.441.143.452.245s-.182.192-.456.208a1.111,1.111,0,0,0,.353.478.817.817,0,0,1,.641-.008c.143.086.124.234-.029.361a3.258,3.258,0,0,0,.769.2.333.333,0,0,1,.366-.285.512.512,0,0,1,.439.293,2.494,2.494,0,0,0,.5-.109c-.168-.134-.217-.275-.1-.347a.833.833,0,0,1,.638.052.792.792,0,0,0,.225-.324c-.283-.042-.5-.144-.509-.254s.2-.2.494-.211A1.137,1.137,0,0,0,117.552,77.54Z",
    transform: "translate(-112.955 -76.319)",
    fill: "#dfc4b7"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_161",
    "data-name": "Path 161",
    d: "M119.357,79.085v.875L101.575,90.208v-.875Z",
    transform: "translate(-90.886 -75.593)",
    fill: "#ad887f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11789",
    "data-name": "Group 11789",
    transform: "translate(51.294)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_162",
    "data-name": "Path 162",
    d: "M111.887,69.618c0,1.906,2.748,3.453,6.137,3.453s6.137-1.547,6.137-3.453-2.747-3.454-6.137-3.454S111.887,67.709,111.887,69.618Z",
    transform: "translate(-110.821 -24.662)",
    fill: "#ceafa3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_163",
    "data-name": "Path 163",
    d: "M122.1,71.024a5.437,5.437,0,0,0,1.689-3.69c-.024-1.654-6.519.506-6.519.506Z",
    transform: "translate(-109.409 -24.519)",
    fill: "#ceafa3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164",
    "data-name": "Path 164",
    d: "M112.734,71.024a5.436,5.436,0,0,1-1.69-3.69c.024-1.654,6.519.506,6.519.506Z",
    transform: "translate(-111.043 -24.519)",
    fill: "#ceafa3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17",
    "data-name": "Rectangle 17",
    width: 14.406,
    height: 25.259,
    transform: "translate(0 17.192)",
    fill: "#dfc4b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_165",
    "data-name": "Path 165",
    d: "M111.043,67.759c0,2.24,3.224,4.054,7.2,4.054s7.2-1.814,7.2-4.054-3.226-4.054-7.2-4.054S111.043,65.52,111.043,67.759Z",
    transform: "translate(-111.043 -25.308)",
    fill: "#dfc4b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_166",
    "data-name": "Path 166",
    d: "M111.043,47.752c0,2.238,3.224,4.054,7.2,4.054s7.2-1.815,7.2-4.054-3.226-4.054-7.2-4.054S111.043,45.512,111.043,47.752Z",
    transform: "translate(-111.043 -30.559)",
    fill: "#ceafa3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_167",
    "data-name": "Path 167",
    d: "M114.96,54.408a12.128,12.128,0,0,0,2.228.208c3.978,0,7.2-1.814,7.2-4.054v17.61c0,2.238-3.224,4.054-7.2,4.054a12.238,12.238,0,0,1-2.228-.208Z",
    transform: "translate(-110.014 -28.758)",
    fill: "#34324c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_168",
    "data-name": "Path 168",
    d: "M116.864,40.8l3.144-.223a28.744,28.744,0,0,1,3.747,7.124c.784,2.776-3.026,2.759-6.891,2.094Z",
    transform: "translate(-109.515 -31.378)",
    fill: "#ceafa3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_169",
    "data-name": "Path 169",
    d: "M119.216,40.8l-4.327-.223a28.744,28.744,0,0,0-3.747,7.124c-.784,2.776,4.209,2.759,8.074,2.094Z",
    transform: "translate(-111.038 -31.378)",
    fill: "#ceafa3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_170",
    "data-name": "Path 170",
    d: "M113.982,41.364c0,1.072,1.543,1.94,3.447,1.94s3.447-.869,3.447-1.94-1.543-1.939-3.447-1.939S113.982,40.294,113.982,41.364Z",
    transform: "translate(-110.271 -31.681)",
    fill: "#dfc4b7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18",
    "data-name": "Rectangle 18",
    width: 6.893,
    height: 2.695,
    transform: "translate(3.711 6.989)",
    fill: "#dfc4b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_171",
    "data-name": "Path 171",
    d: "M113.982,39.23c0,1.071,1.543,1.939,3.447,1.939s3.447-.869,3.447-1.939-1.543-1.94-3.447-1.94S113.982,38.159,113.982,39.23Z",
    transform: "translate(-110.271 -32.241)",
    fill: "#efd9d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_172",
    "data-name": "Path 172",
    d: "M114.96,38.944c0,.675.973,1.223,2.174,1.223s2.173-.548,2.173-1.223-.972-1.223-2.173-1.223S114.96,38.269,114.96,38.944Z",
    transform: "translate(-110.014 -32.128)",
    fill: "#ceafa3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19",
    "data-name": "Rectangle 19",
    width: 4.347,
    height: 2.022,
    transform: "translate(4.946 4.794)",
    fill: "#656c9a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_173",
    "data-name": "Path 173",
    d: "M115.723,55.685a10.916,10.916,0,0,0,2,.188c3.572,0,6.468-1.63,6.468-3.64v.939c0,2.01-2.9,3.64-6.468,3.64a11.031,11.031,0,0,1-2-.187Z",
    transform: "translate(-109.814 -28.319)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_174",
    "data-name": "Path 174",
    d: "M120.426,57.832s2.563,4.284,0,5.812S120.426,57.832,120.426,57.832Z",
    transform: "translate(-108.879 -26.849)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11788",
    "data-name": "Group 11788",
    transform: "translate(3.537)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_175",
    "data-name": "Path 175",
    d: "M117.919,34.889v5.448a6.11,6.11,0,0,1-1.235.13V34.889Z",
    transform: "translate(-113.099 -32.872)",
    fill: "#34324c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_176",
    "data-name": "Path 176",
    d: "M116.585,34.889v5.556a6,6,0,0,1-1.034-.146v-5.41Z",
    transform: "translate(-113.396 -32.872)",
    fill: "#34324c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_177",
    "data-name": "Path 177",
    d: "M119.009,34.889v4.9a3.982,3.982,0,0,1-1.034.451V34.889Z",
    transform: "translate(-112.76 -32.872)",
    fill: "#34324c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_178",
    "data-name": "Path 178",
    d: "M115.448,34.889v5.289a3.665,3.665,0,0,1-1.016-.511V34.889Z",
    transform: "translate(-113.69 -32.872)",
    fill: "#34324c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_179",
    "data-name": "Path 179",
    d: "M113.844,34.889h.346V39.3a1.338,1.338,0,0,1-.346-.852Z",
    transform: "translate(-113.844 -32.872)",
    fill: "#34324c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_180",
    "data-name": "Path 180",
    d: "M119.628,34.889V38.45a1.438,1.438,0,0,1-.52,1.033V34.889Z",
    transform: "translate(-112.462 -32.872)",
    fill: "#34324c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_181",
    "data-name": "Path 181",
    d: "M119.19,34.889v4.594a2.6,2.6,0,0,1-.4.3v-4.9Z",
    transform: "translate(-112.545 -32.872)",
    fill: "#23203a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_182",
    "data-name": "Path 182",
    d: "M118.057,34.889v5.347c-.129.038-.259.072-.4.1V34.889Z",
    transform: "translate(-112.842 -32.872)",
    fill: "#23203a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_183",
    "data-name": "Path 183",
    d: "M116.766,34.889v5.578h0c-.135,0-.263-.015-.394-.023V34.889Z",
    transform: "translate(-113.181 -32.872)",
    fill: "#23203a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_184",
    "data-name": "Path 184",
    d: "M115.633,34.889V40.3c-.139-.034-.266-.078-.4-.121V34.889Z",
    transform: "translate(-113.478 -32.872)",
    fill: "#23203a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_185",
    "data-name": "Path 185",
    d: "M114.514,34.889v4.777a2.211,2.211,0,0,1-.4-.364V34.889Z",
    transform: "translate(-113.772 -32.872)",
    fill: "#23203a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_186",
    "data-name": "Path 186",
    d: "M113.844,35.308c0,1.114,1.6,2.016,3.583,2.016s3.583-.9,3.583-2.016-1.6-2.017-3.583-2.017S113.844,34.195,113.844,35.308Z",
    transform: "translate(-113.844 -33.291)",
    fill: "#44435e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_187",
    "data-name": "Path 187",
    d: "M114.432,35.215c0,.866,1.247,1.568,2.786,1.568s2.788-.7,2.788-1.568-1.249-1.569-2.788-1.569S114.432,34.349,114.432,35.215Z",
    transform: "translate(-113.69 -33.198)",
    fill: "#34324c"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11793",
    "data-name": "Group 11793",
    transform: "translate(365.529 299.688)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_188",
    "data-name": "Path 188",
    d: "M323.562,267.069s4.149.191,7.62,9.409,3.151,10.182,2.683,13.164c-.7,4.44-4.8,10.493-7.891,13.863a38.429,38.429,0,0,1-6.105,5.4l-4.31-6Z",
    transform: "translate(-292.784 -239.293)",
    fill: "#ffc5b3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11791",
    "data-name": "Group 11791",
    transform: "translate(14.42 100.012)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_189",
    "data-name": "Path 189",
    d: "M317.43,377.679c-2.49-1.245-4.854-2.767-4.1-4.186a2.521,2.521,0,0,1,1.9-1.053c2.3.755,3.44,1.269,3.44,1.269s.2-16.175-.75-28.852a107.8,107.8,0,0,0-2.771-16.465c-.323-1.821,10.216-4.106,10.216-4.106-2.742,1.2,1.975,9.469,2.352,18.542.485,11.674-1.562,25.6-1.891,29.44a20.053,20.053,0,0,0,.1,4.886c-.592.258-1.816.789-2.726,1.2C321.955,378.923,319.918,378.923,317.43,377.679Z",
    transform: "translate(-307.826 -324.286)",
    fill: "#ffc5b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_190",
    "data-name": "Path 190",
    d: "M327.142,370.967c-.832,1.981-2.751,1.8-6.628.4a33.342,33.342,0,0,1-8.725-4.449c-2.448-1.81-2.472-2.05-2.8-3.275-.453-1.714,2.049-2.675,6.209-1.382.412.128.789.249,1.145.366a2.521,2.521,0,0,0-1.9,1.053c-.756,1.419,1.608,2.942,4.1,4.186s4.525,1.244,5.77.678c.91-.414,2.134-.946,2.726-1.2C327.292,369.005,327.642,369.778,327.142,370.967Z",
    transform: "translate(-308.941 -314.475)",
    fill: "#23203a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11792",
    "data-name": "Group 11792",
    transform: "translate(0.743 106.046)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_191",
    "data-name": "Path 191",
    d: "M306.6,384.279c-2.49-1.245-4.853-2.766-4.1-4.186a2.518,2.518,0,0,1,1.9-1.053c2.3.755,3.442,1.269,3.442,1.269s-1.791-44.913-2.774-50.434c-.323-1.82,10.966,0,10.966,0a42.07,42.07,0,0,0-.872,8.547c1.228,5.094,1.012,10.668.287,18.772a158.935,158.935,0,0,0-.355,26.56c-.593.258-1.815.789-2.727,1.2C311.12,385.523,309.084,385.523,306.6,384.279Z",
    transform: "translate(-296.992 -329.065)",
    fill: "#ffc5b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_192",
    "data-name": "Path 192",
    d: "M316.308,377.188c-.832,1.981-2.75,1.8-6.628.4a33.381,33.381,0,0,1-8.725-4.449c-2.447-1.809-2.472-2.05-2.8-3.275-.452-1.714,2.049-2.675,6.21-1.382.41.127.789.249,1.144.366a2.518,2.518,0,0,0-1.9,1.053c-.756,1.42,1.607,2.942,4.1,4.186s4.525,1.245,5.77.678c.912-.414,2.134-.946,2.727-1.2C316.46,375.228,316.808,376,316.308,377.188Z",
    transform: "translate(-298.107 -318.875)",
    fill: "#23203a"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_193",
    "data-name": "Path 193",
    d: "M314.47,248.906c-.962.667-4.547,1.491-5.55,9.392-.888,7,.654,8.824,2.077,9.416a16.357,16.357,0,0,0,3.58.317l-.107,5.914a10.035,10.035,0,0,0,6.791,0l3.325-1.371a11.7,11.7,0,0,1-1.082-6.115c.269-4.808,1.972-11.653.768-14.2C322.094,247.66,317.079,247.095,314.47,248.906Z",
    transform: "translate(-294.595 -244.312)",
    fill: "#ffc5b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_194",
    "data-name": "Path 194",
    d: "M306.507,306.988c1.211-5.511,1.581-17.281,1.581-17.281s-2.688-8.181-.136-13.3,5.311-6.384,7.754-7.211c2.588-.876,10.469-3.044,10.469-3.044s6.689,8.207,4.945,15.885c-2.9,12.785-7.609,15.006-6.705,21.028,0,0,5.233,10.7,5.964,13.713.949,3.914,3.582,31.262,3.582,31.262s-10.224,7.936-18.8,6.9c-7-.843-12.805-6.9-12.805-6.9S305.294,312.519,306.507,306.988Z",
    transform: "translate(-296.25 -239.534)",
    fill: "#ea6f53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_195",
    "data-name": "Path 195",
    d: "M312.359,272.294c-1.48.14-3.689,2.77-5.321,8.5-1.541,5.412-1.63,15.12-2.521,19.154-.636,1.82-3.527,15.385-4.305,20.067a20.453,20.453,0,0,0-2.689,10.1c-.128,7.071,3.155,7.55,4.939,5.395,1.462-1.768,2.118-9.775,2.308-12.61a52.558,52.558,0,0,1,3.987-10.583c.91-1.707,3.178-6.381,3.692-8.825,1.336-6.36,3.77-18.427,3.967-22.83C316.629,275.9,314.453,272.094,312.359,272.294Z",
    transform: "translate(-297.519 -237.923)",
    fill: "#ffc5b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_196",
    "data-name": "Path 196",
    d: "M310.511,257.4s2.076-3.558,2.968,0a3.614,3.614,0,0,1-2.052,4.415Z",
    transform: "translate(-294.109 -242.245)",
    fill: "#ffc5b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_197",
    "data-name": "Path 197",
    d: "M313.855,246.924c2.093-.965,4.584-3.43,9.21-.378s7.363,10.431,7.04,13.8-2.934,7.243,2.029,10.005,5.57,4.34,4.178,8.212c-1.353,3.767-3.526,5.622-.653,7.537,3.973,2.65,3.721,7.678,2.221,9.349-2.665,2.967-4.661,2.161-4.33,4.167.569,3.454,3.024,7.2-1.155,9-4.438,1.914-6.792-.886-6.792-.886s4.5.29,4.5-3.137c0-3.332-2.573-.994-8.683-1.567-6.958-.654-6.978-3.909-7.279-9.562s-8.162-6.214-5.133-10.445,6.775-5.43,2.338-6.862c-2.338-.754-2.586-5.777-1.74-7.67,1.307-2.921,5.329-4.26,2.483-6.843-1.552-1.409-6.146-2.467-4.352-10.214C308.217,249.363,311.447,248.034,313.855,246.924Z",
    transform: "translate(-294.944 -245.068)",
    fill: "#23203a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_198",
    "data-name": "Path 198",
    d: "M334.466,332.862s1.722,6.372,1.467,8.64-2.089,1.616-4.7,3.059.656,4.968-3.527,4.968c-2.976,0,.1,5.094-5.883,3.708-5.068-1.175-1.307,2.442-3.4,3.425a14.73,14.73,0,0,1-7.085,1.1c-3.617-.2-2.717,3.1-7.046,2.423-1.512-.235-3.967-2.666-4.446-4.433s4.65-38.065,4.65-38.065,1.855,14.577,12.206,15.179A141.5,141.5,0,0,0,334.466,332.862Z",
    transform: "translate(-296.917 -226.007)",
    fill: "#e05a44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_199",
    "data-name": "Path 199",
    d: "M333.605,331.65c.317,3.2.379,3.842.379,3.842a24.732,24.732,0,0,1-18.594,1.095,20.853,20.853,0,0,1-12.818-12.362l1.338-7.134s4.474,11.022,14.19,13.978C327.113,333.812,333.605,331.65,333.605,331.65Z",
    transform: "translate(-296.193 -226.163)",
    fill: "#dfc4b7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11813",
    "data-name": "Group 11813",
    transform: "translate(81.436 119.309)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11811",
    "data-name": "Group 11811",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11799",
    "data-name": "Group 11799",
    transform: "translate(11.836)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_200",
    "data-name": "Path 200",
    d: "M218.641,260.557l-33.415-19.57s5.852-11.381,20.144-7.416,22.408,8.94,22.408,8.94Z",
    transform: "translate(-54.738 -67.927)",
    fill: "#ce4638"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11794",
    "data-name": "Group 11794",
    transform: "translate(114.281 171.601)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_201",
    "data-name": "Path 201",
    d: "M208.635,253.992c-.014,13.338-8.138,28.825-18.147,34.59s-18.113-.372-18.1-13.711,8.138-28.824,18.148-34.59S208.648,240.655,208.635,253.992Z",
    transform: "translate(-172.388 -238.115)",
    fill: "#23203a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_202",
    "data-name": "Path 202",
    d: "M177.771,289.709,189.5,296.5l22-51.044-12.2-6.967Z",
    transform: "translate(-170.975 -238.017)",
    fill: "#23203a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_203",
    "data-name": "Path 203",
    d: "M217.946,259.381c-.013,13.338-8.137,28.824-18.147,34.59s-18.112-.372-18.1-13.711,8.138-28.825,18.147-34.59S217.96,246.043,217.946,259.381Z",
    transform: "translate(-169.944 -236.7)",
    fill: "#34324c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_204",
    "data-name": "Path 204",
    d: "M211.791,260.778c-.01,9.587-5.85,20.719-13.044,24.863s-13.02-.269-13.01-9.855,5.849-20.72,13.044-24.863S211.8,251.19,211.791,260.778Z",
    transform: "translate(-168.884 -235.162)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_205",
    "data-name": "Path 205",
    d: "M204.62,262.523c-.005,4.9-2.988,10.583-6.663,12.7s-6.649-.136-6.646-5.034,2.988-10.585,6.663-12.7S204.625,257.626,204.62,262.523Z",
    transform: "translate(-167.421 -233.238)",
    fill: "#34324c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_206",
    "data-name": "Path 206",
    d: "M203.278,262.828c0,4.08-2.49,8.817-5.551,10.581s-5.54-.115-5.536-4.194,2.49-8.817,5.551-10.581S203.282,258.747,203.278,262.828Z",
    transform: "translate(-167.19 -232.903)",
    fill: "#bc978b"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_207",
    "data-name": "Path 207",
    d: "M328.606,197.107l-33.417-19.57s5.852-11.38,20.144-7.416,22.408,8.94,22.408,8.94Z",
    transform: "translate(-25.874 -84.582)",
    fill: "#ce4638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_208",
    "data-name": "Path 208",
    d: "M369.04,144.275s-40.065-32.388-71.842-39.528c-13.222-2.971-27.449,3.583-38.473,4.516l-11.857,11.543,85.308,52.442,34.941-18.608C370.376,152.745,372.295,146.179,369.04,144.275Z",
    transform: "translate(-38.557 -101.723)",
    fill: "#ee0d09"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11795",
    "data-name": "Group 11795",
    transform: "translate(59.01 57.005)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_209",
    "data-name": "Path 209",
    d: "M131.362,188.644c3.753,4.58,11.335,11.563,26.315,22.078,36.18,25.395,61.845,23.5,61.845,23.5l20.046-35.266c-20.956-9.7-52.512-23.645-65.94-26.189S142.41,180.751,131.362,188.644Z",
    transform: "translate(-127.886 -140.774)",
    fill: "#7d86b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_210",
    "data-name": "Path 210",
    d: "M162.716,147.345l-33.586,39.722s-2.36,1.666,2.954,8.148c11.048-7.893,28.834-18.423,42.267-15.877s44.984,16.489,65.94,26.189l5.488-9.657Z",
    transform: "translate(-128.609 -147.345)",
    fill: "#a6acc6"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_211",
    "data-name": "Path 211",
    d: "M155.625,159.191s3.662,5.35,25.584,20.592c20.426,14.2,57.479,27.933,57.479,27.933s26.508-20.067,47.516-31.73S343.882,149,343.882,149l-61.207-39.271s-16.165-15.9-43.889-1.438c-10.412,5.431-29.218,17-55.611,33.046C173.316,147.327,163.449,153.852,155.625,159.191Z",
    transform: "translate(-62.507 -102.186)",
    fill: "#ee0d09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_212",
    "data-name": "Path 212",
    d: "M157.667,163.511s18.373-11.2,44.557-26.115S262.5,102.813,262.5,102.813l3.179,1s-14.155,8.5-27.44,15.842c-10.784,5.955-79.331,46.054-79.331,46.054Z",
    transform: "translate(-61.971 -102.029)",
    fill: "#ea6f53",
    opacity: 0.49
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_213",
    "data-name": "Path 213",
    d: "M209.142,193.535s18.373-11.2,44.558-26.115,60.276-34.582,60.276-34.582l3.178,1s-14.155,8.5-27.44,15.84c-10.784,5.958-79.331,46.056-79.331,46.056Z",
    transform: "translate(-48.46 -94.148)",
    fill: "#ea6f53",
    opacity: 0.49
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_214",
    "data-name": "Path 214",
    d: "M298.791,135.852l17.672,3.078,17.852,9.8s-34.848-4.551-38.358-6.007S298.791,135.852,298.791,135.852Z",
    transform: "translate(-25.95 -93.357)",
    fill: "#ff8f80"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11796",
    "data-name": "Group 11796",
    transform: "translate(253.11 91.496)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_215",
    "data-name": "Path 215",
    d: "M318.6,190.542c-.014,13.338-8.138,28.825-18.147,34.591s-18.112-.374-18.1-13.711,8.138-28.825,18.147-34.591S318.613,177.205,318.6,190.542Z",
    transform: "translate(-282.353 -174.665)",
    fill: "#23203a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_216",
    "data-name": "Path 216",
    d: "M287.736,226.259l11.725,6.791,22-51.044-12.2-6.966Z",
    transform: "translate(-280.94 -174.567)",
    fill: "#23203a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_217",
    "data-name": "Path 217",
    d: "M327.911,195.931c-.014,13.337-8.138,28.824-18.147,34.59s-18.113-.372-18.1-13.711,8.138-28.824,18.147-34.59S327.924,182.593,327.911,195.931Z",
    transform: "translate(-279.909 -173.25)",
    fill: "#34324c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_218",
    "data-name": "Path 218",
    d: "M321.755,197.328c-.009,9.587-5.849,20.719-13.044,24.863s-13.019-.268-13.01-9.855,5.85-20.72,13.044-24.863S321.765,187.74,321.755,197.328Z",
    transform: "translate(-278.849 -171.712)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_219",
    "data-name": "Path 219",
    d: "M314.584,199.074c0,4.9-2.988,10.583-6.662,12.7s-6.651-.136-6.646-5.034,2.988-10.583,6.662-12.7S314.589,194.176,314.584,199.074Z",
    transform: "translate(-277.386 -169.788)",
    fill: "#34324c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_220",
    "data-name": "Path 220",
    d: "M313.243,199.378c-.005,4.08-2.49,8.817-5.551,10.581s-5.541-.114-5.537-4.194,2.49-8.817,5.551-10.581S313.247,195.3,313.243,199.378Z",
    transform: "translate(-277.155 -169.453)",
    fill: "#bc978b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11797",
    "data-name": "Group 11797",
    transform: "translate(0.063 42.552)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_221",
    "data-name": "Path 221",
    d: "M412.337,135.9c-7.9,1.442-15.053,12.972-29.31,10.339-3.974-.734-16.162-5.368-26.165-4.656-10.647.758-16.544,4.72-26.13,10.4-7.6,4.5-34.654,19.783-55.345,33.089-11.587,7.452-19.606,11.879-22.624,16.879-2.092,3.466-9.475,20.7-16.665,34.146a34.618,34.618,0,0,1-5.344,7.387L99.439,219.193S92.055,226.85,87.3,240.721c-1.8,5.244-7.285,18.406-4.7,30.33,2.342,10.813,9.985,22.114,23.889,30.166,47.98,27.789,75.078,21.433,95.049,10.3.074-17.685,10.838-38.164,24.1-45.8,13.242-7.628,23.965.438,24.031,18.009,28.193-16.277,64.2-37.06,93.14-53.767.588-4.656,3.079-19.71,5.656-24.119,5.167-8.841,18.2-21.085,23.99-20.513,18.5,1.831,10.838,21.264,14.045,19.413l7.066-4.078c14.522-8.355,21.917-24.954,24.3-35.427C419.175,159.437,418.757,140.13,412.337,135.9Z",
    transform: "translate(-81.918 -135.897)",
    fill: "#ee0d09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_222",
    "data-name": "Path 222",
    d: "M364.837,191.838c-.074-19.6-12.033-28.592-26.8-20.085-6.482,3.733-12.427,10.22-17.07,17.987-2.483,1.531-5.071,3.152-7.735,4.866-13.992,8.993-74.265,43.389-96.492,56.038-4.667-2.577-10.7-2.294-17.3,1.51-14.786,8.518-26.791,31.356-26.873,51.079q1.036-.578,2.05-1.17c.372-.217,1.4-.814,2.955-1.712,0-.192,3.01-1.322,3.01-1.515.016-16.323,9.009-34.21,21.258-41.266a18.634,18.634,0,0,1,7.226-2.562l-.6.342,7.8,1.636c3.613,2.952,5.652,8.935,5.643,17.251,0,.17-.016.345-.019.515l4.354-2.514c-.026-7.057-1.613-12.713-4.3-16.7,0,0,44.817-25.038,59.757-33.383,8.2-4.582,31.923-15.488,31.923-15.488-1.315,3.026-2.058,8.409-2.458,16.162q1.036-.578,2.05-1.169c.372-.217,1.4-.814,2.956-1.713,0-.191,3.01-1.321,3.011-1.515a53.131,53.131,0,0,1,3.93-19.412l.954-.533,7.526-10.977,10.158-9.635c1.648-1.054-1.514.545-7.306,3.852a31.927,31.927,0,0,1,5.994-4.559c12.249-7.056,21.331.129,21.316,16.45,0,.17-1.266.562-1.268.732Z",
    transform: "translate(-58.125 -127.327)",
    fill: "#ff816c",
    opacity: 0.33
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_223",
    "data-name": "Path 223",
    d: "M200.761,239.319c-13.259,7.638-24.023,28.117-24.1,45.8q.928-.519,1.838-1.049c.335-.2,1.257-.73,2.65-1.535,0-.173-.019-.331-.019-.505.015-14.636,8.93-31.629,19.912-37.955s19.875.41,19.861,15.045c0,.153-.016.309-.019.462l3.9-2.255C224.726,239.757,214,231.691,200.761,239.319Z",
    transform: "translate(-57.048 -109.505)",
    fill: "#e05a44"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_224",
    "data-name": "Path 224",
    d: "M262.547,113.332s12.462-8.392,26.88-5.087,30.526,14.782,30.526,14.782l-25.142,10.12Z",
    transform: "translate(-34.442 -100.806)",
    fill: "#ff8f80",
    opacity: 0.41
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_225",
    "data-name": "Path 225",
    d: "M310.725,175.869c-13.259,7.638-24.023,28.117-24.1,45.8q.93-.519,1.839-1.049c.333-.194,1.256-.73,2.649-1.536,0-.17-.019-.33-.019-.5.015-14.635,8.93-31.629,19.913-37.954s19.874.409,19.86,15.044c0,.153-.016.309-.018.462l3.9-2.255C334.691,176.307,323.967,168.241,310.725,175.869Z",
    transform: "translate(-28.121 -83.608)",
    fill: "#e05a44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_226",
    "data-name": "Path 226",
    d: "M138.91,178.808s-16.475,11.635-39.3,26.947c-11.246,7.543-14.265,27.452,12.212,44.77,30.928,20.23,53.45,19.416,73.1,7.966,21.13-12.308,45.1-25.955,45.1-25.955s-16.255-.091-48.679-19.317A184.118,184.118,0,0,1,138.91,178.808Z",
    transform: "translate(-79.378 -82.081)",
    fill: "#34324c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_227",
    "data-name": "Path 227",
    d: "M213.6,238.424a3.072,3.072,0,0,1-4.366-3.857c5.444-12.783,15.777-35.991,20.215-38.861,5.776-3.732,25.832-15.705,50.3-30.211,18.1-10.725,34.15-20.058,41.721-17.948,2.938.819,10.97,6.3,16.834,10.487a5.348,5.348,0,0,1-.456,8.989Z",
    transform: "translate(-48.504 -90.366)",
    fill: "#34324c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_228",
    "data-name": "Path 228",
    d: "M239.8,102.231s24.534,13.438,35.606,20.719c16.451,10.816,38.52,22.9,38.52,22.9l25.033,6.458c-6.81-4.136,0,0-13.174-7.407C307,134.337,286.511,121.3,283.171,119.238c-4.58-2.834-13.452-7.487-18.2-9.921C255.289,104.355,242.815,101.844,239.8,102.231Z",
    transform: "translate(-40.413 -102.192)",
    fill: "#44435e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_229",
    "data-name": "Path 229",
    d: "M131.6,264.255c2.63-5.007,7.264-8.774,12.882-8.119,4.26.5,4.829-.177,11.755-.866a47.952,47.952,0,0,0,18.527-6.3c4.874-2.9,5.309,2.073,4.777,3.949-1.982,7.009-7.567,12.273-14.714,14.6C147.878,273.037,131.6,264.255,131.6,264.255Z",
    transform: "translate(-68.814 -63.897)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11798",
    "data-name": "Group 11798",
    transform: "translate(13.491 155.295)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_230",
    "data-name": "Path 230",
    d: "M133.667,253.2c4.583.968,9.286,2.089,12.39,2.774l.813-.925s-21.807-4.9-36.942-15.344A53.662,53.662,0,0,1,95.4,225.2l-.534,1.953a60.327,60.327,0,0,0,5.549,8.118C106.534,242.985,126.128,251.606,133.667,253.2Z",
    transform: "translate(-91.948 -225.199)",
    fill: "#34324c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_231",
    "data-name": "Path 231",
    d: "M132.549,256.418c3.649.771,7.552,1.674,10.609,2.366l1.843-2.1c-3.381-.708-7.945-1.719-12.309-2.862-8.375-2.194-20.4-8.575-28.3-13.918a30.761,30.761,0,0,1-9.784-11.6l-.828,3.031a51.382,51.382,0,0,0,5.511,7.153C105.893,245.8,125.008,254.824,132.549,256.418Z",
    transform: "translate(-92.232 -224.385)",
    fill: "#34324c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_232",
    "data-name": "Path 232",
    d: "M101.636,246.536a30.052,30.052,0,0,1-9.082-10.268,10.479,10.479,0,0,0,3.469,7.926,67.3,67.3,0,0,0,12.757,9.091,189.76,189.76,0,0,0,21.159,10A8.925,8.925,0,0,0,138,262.4c-2.544-.569-5.34-1.23-8.061-1.942C121.56,258.259,109.533,251.88,101.636,246.536Z",
    transform: "translate(-92.554 -222.294)",
    fill: "#34324c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_233",
    "data-name": "Path 233",
    d: "M103.247,242.866a36.673,36.673,0,0,1-9.791-10.485l-.6,2.2c-.027.1-.035.2-.059.3a69.6,69.6,0,0,0,5.076,7.233c6.124,7.715,25.718,16.337,33.259,17.931,2.852.6,5.891,1.286,8.563,1.887.038-.042.082-.074.119-.116l2.237-2.545c-3.111-.67-6.879-1.53-10.505-2.479C123.17,254.591,111.142,248.21,103.247,242.866Z",
    transform: "translate(-92.49 -223.314)",
    fill: "#34324c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_234",
    "data-name": "Path 234",
    d: "M97.937,241.588a69.6,69.6,0,0,1-5.076-7.233,10.666,10.666,0,0,0-.307,2.415,30.053,30.053,0,0,0,9.082,10.268c7.9,5.344,19.923,11.723,28.3,13.918,2.721.712,5.517,1.372,8.061,1.942a9.016,9.016,0,0,0,1.764-1.491c-2.673-.6-5.712-1.284-8.563-1.887C123.655,257.924,104.062,249.3,97.937,241.588Z",
    transform: "translate(-92.554 -222.796)",
    fill: "#44435e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_235",
    "data-name": "Path 235",
    d: "M132.669,255.787c-7.541-1.593-26.656-10.621-33.259-17.931A51.385,51.385,0,0,1,93.9,230.7l-.581,2.118a36.674,36.674,0,0,0,9.791,10.485c7.9,5.344,19.923,11.725,28.3,13.918,3.626.949,7.394,1.809,10.505,2.479l1.363-1.55C140.222,257.461,136.318,256.559,132.669,255.787Z",
    transform: "translate(-92.353 -223.754)",
    fill: "#44435e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_236",
    "data-name": "Path 236",
    d: "M104.219,240.314c7.9,5.343,19.925,11.723,28.3,13.918,4.364,1.143,8.928,2.154,12.309,2.862l1.341-1.525c-3.1-.684-7.807-1.805-12.39-2.774-7.54-1.595-27.133-10.216-33.258-17.931a60.329,60.329,0,0,1-5.549-8.118l-.538,1.964A30.761,30.761,0,0,0,104.219,240.314Z",
    transform: "translate(-92.06 -224.793)",
    fill: "#44435e"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_237",
    "data-name": "Path 237",
    d: "M91.067,209.959s-.545,6.844-.553,14.294c-.005,5.555-2.375,13.125-2.375,13.125s-2.775-10.5-2.394-14.286A27.033,27.033,0,0,1,91.067,209.959Z",
    transform: "translate(-80.859 -73.905)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_238",
    "data-name": "Path 238",
    d: "M89.91,255.176s.021-13.7,8.575-7.766a147.807,147.807,0,0,0,20.071,12.149c6.354,3,10.915,5.167,12.707,8.478,1.818,3.359,1.886,12.18,1.886,12.18s-6.023-.312-26.487-11.877C91.319,259.669,89.91,255.176,89.91,255.176Z",
    transform: "translate(-79.757 -64.466)",
    fill: "#34324c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_239",
    "data-name": "Path 239",
    d: "M95,248.763l-.008,8.2s6.3,4.454,11.361,7.743c3.3,2.141,15.9,7.906,15.9,7.906l.008-7.884s-8.931-4.035-15.9-8.064A84.041,84.041,0,0,1,95,248.763Z",
    transform: "translate(-78.423 -63.719)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240",
    "data-name": "Path 240",
    d: "M81.964,238.846s-1.179,11.835,4.712,20.407,20.8,23.893,47.294,31.5c29.646,8.507,48.57,5.809,59.545.881s12.235-4.57,12.52-9.724-4.484-1.632-4.484-1.632S196.716,288.4,173.7,289.8c-12.192.742-27.9-1.477-40.984-5.378-11.616-3.463-23.052-10.541-34.288-18.73C82.6,254.152,81.964,238.846,81.964,238.846Z",
    transform: "translate(-81.868 -66.322)",
    fill: "#e05a44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241",
    "data-name": "Path 241",
    d: "M137.7,269.789a1.679,1.679,0,0,0-1.425,2.507,15.884,15.884,0,0,0,2.955,4.025c3.8,3.508,21.134,3.757,23.078,1.953s.643-7.458-3.978-7.3C151.945,271.2,143.2,269.7,137.7,269.789Z",
    transform: "translate(-67.642 -58.201)",
    fill: "#34324c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_242",
    "data-name": "Path 242",
    d: "M83.064,229.807s1.286,5.925,2.163,8.229-3.282,3.183-3.282,3.183A59.979,59.979,0,0,1,83.064,229.807Z",
    transform: "translate(-81.848 -68.695)",
    fill: "#34324c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_243",
    "data-name": "Path 243",
    d: "M114.552,247.485c-.515,1.611-3.519,1.736-6.706.279s-5.355-3.944-4.84-5.555,3.52-1.736,6.708-.279S115.069,245.874,114.552,247.485Z",
    transform: "translate(-76.339 -65.779)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_244",
    "data-name": "Path 244",
    d: "M126.35,181.181s2.072,4.772,13.54,13.76c11.076,8.681,35.187,25.718,51,32.057s25.96,10.316,29.946,5.537,24.2-45.707,24.2-45.707l-2.3-.952s-21.53,41.877-24.167,44.178-22.682-5.29-58.246-28.46c-13.5-8.794-30.6-22.787-30.6-22.787Z",
    transform: "translate(-70.192 -82.081)",
    fill: "#34324c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_245",
    "data-name": "Path 245",
    d: "M155.957,147.345l-1.6,1.889a182.953,182.953,0,0,0,28.3,21.339c15.775,9.454,53.51,26.611,53.51,26.611l1.516-2.1S202.6,180.25,183.736,167.72,155.957,147.345,155.957,147.345Z",
    transform: "translate(-62.84 -90.34)",
    fill: "#34324c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_246",
    "data-name": "Path 246",
    d: "M308.8,205.921l-95.407,55.02-.005,5.368,1.409-.814,95.188-54.9Z",
    transform: "translate(-47.346 -74.965)",
    fill: "#e05a44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_247",
    "data-name": "Path 247",
    d: "M262.166,170.948l-.028,27.656L221.4,222.125s-.091-10.506.014-14.782a24.837,24.837,0,0,1,2.534-9.57,23.875,23.875,0,0,1,8.5-8.994C243.372,182.083,262.166,170.948,262.166,170.948Z",
    transform: "translate(-45.252 -84.145)",
    fill: "#7d86b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_248",
    "data-name": "Path 248",
    d: "M257.907,173.637l-.028,27.776,43.005-25.26s.047-10.549-.519-13.723c-.5-2.781-1.987-11.128-1.987-11.128Z",
    transform: "translate(-35.667 -89.301)",
    fill: "#7d86b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_249",
    "data-name": "Path 249",
    d: "M293.082,150.385s1.573,7.84,2.007,10.658c.431,2.78.662,13.187.662,13.187s9.769-5.889,12.02-7.04,4.064-4.44-1.857-8.89A139.325,139.325,0,0,0,293.082,150.385Z",
    transform: "translate(-26.427 -89.542)",
    fill: "#7d86b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_250",
    "data-name": "Path 250",
    d: "M347.641,142.681l-.553.362a5.659,5.659,0,0,0-2.57,4.739l-.006,6.3a91.582,91.582,0,0,1-.9,11.4l5.867-3.661a23.848,23.848,0,0,0,1.618-13.309C350.309,144.217,347.641,142.681,347.641,142.681Z",
    transform: "translate(-13.162 -91.564)",
    fill: "#34324c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_251",
    "data-name": "Path 251",
    d: "M320.393,178.413s18.148-8.181,30.844-17.46a47.285,47.285,0,0,0,5.282-5.166s1.587,2.357-4.093,10.147c-1.924,2.639-21.9,17.09-28.011,19.161C321.589,178.458,320.393,178.413,320.393,178.413Z",
    transform: "translate(-19.258 -88.124)",
    fill: "#ff816c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11805",
    "data-name": "Group 11805",
    transform: "translate(39.344 115.453)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11800",
    "data-name": "Group 11800",
    transform: "translate(7.343 5.589)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_252",
    "data-name": "Path 252",
    d: "M116.593,224.9a1.594,1.594,0,0,1-.634-.131c-.629-.271-6.169-2.771-6.473-6.728-.162-2.088,1.09-3.984,3.721-5.638,7.981-5.018,28.331-13.828,29.194-14.2a1.6,1.6,0,1,1,1.269,2.938c-.21.091-20.986,9.085-28.759,13.971-.869.547-2.315,1.622-2.235,2.682.122,1.611,3.12,3.418,4.555,4.04a1.6,1.6,0,0,1-.638,3.068Z",
    transform: "translate(-109.473 -198.068)",
    fill: "#dfc4b7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11801",
    "data-name": "Group 11801",
    transform: "translate(13.159)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_253",
    "data-name": "Path 253",
    d: "M125.843,219.946a1.6,1.6,0,0,1-.787-.207c-1.846-1.045-11.046-6.514-10.976-11.558.016-1.2.537-2.891,2.923-4.157,7.542-4,20.983-10.176,21.116-10.239a1.6,1.6,0,1,1,1.334,2.909c-.135.062-13.49,6.2-20.951,10.157-1.214.644-1.221,1.193-1.223,1.375-.033,2.317,5.563,6.579,9.355,8.73a1.6,1.6,0,0,1-.792,2.991Z",
    transform: "translate(-114.08 -193.641)",
    fill: "#dfc4b7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11802",
    "data-name": "Group 11802",
    transform: "translate(0 21.489)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_254",
    "data-name": "Path 254",
    d: "M143.749,211.936a271.446,271.446,0,0,0-29.06,16.964l-.115-1.064-9.114-.468a38.738,38.738,0,0,0-1.8,11.284c0,.561,7.446,5.677,15.851,9.976,7.926,4.055,13.545,6.219,17.574,7.185a6.779,6.779,0,0,0,3.029-1.385,167.242,167.242,0,0,1,18.643-12.964c15.6-9.269,27.815-15.452,29.494-16.058C186.344,224.219,156.322,205.718,143.749,211.936Z",
    transform: "translate(-103.657 -210.662)",
    fill: "#bc978b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_255",
    "data-name": "Path 255",
    d: "M170.66,222.351l.1.061C170.935,222.282,170.889,222.269,170.66,222.351Z",
    transform: "translate(-86.069 -207.607)",
    fill: "#545470"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_256",
    "data-name": "Path 256",
    d: "M106.6,233.441a3.438,3.438,0,0,1-.285-5.777,288.322,288.322,0,0,1,37.117-22.486c12.987-6.422,44.6,13.531,44.6,13.531,1.49-1.083-11.875,5.47-29.591,16a167.1,167.1,0,0,0-18.643,12.963,6.794,6.794,0,0,1-7.672.574Z",
    transform: "translate(-103.337 -190.947)",
    fill: "#dfc4b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_257",
    "data-name": "Path 257",
    d: "M142.356,206.942s-13.384,8.561-19.927,12.082-12.529,8.813-12.6,11.768,2.113,1.986,8.351-2.731,31.034-18.416,31.034-18.416Z",
    transform: "translate(-102.037 -190.149)",
    fill: "#ceafa3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_258",
    "data-name": "Path 258",
    d: "M148.741,211.28s-13.384,8.561-19.927,12.081-12.529,8.815-12.6,11.769,2.113,1.986,8.351-2.731S155.6,213.983,155.6,213.983Z",
    transform: "translate(-100.361 -189.011)",
    fill: "#ceafa3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_259",
    "data-name": "Path 259",
    d: "M156.69,215.089s-13.385,8.562-19.927,12.082-12.53,8.813-12.6,11.768,2.113,1.987,8.351-2.731,31.036-18.415,31.036-18.415Z",
    transform: "translate(-98.275 -188.011)",
    fill: "#ceafa3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11803",
    "data-name": "Group 11803",
    transform: "translate(47.894 34.089)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_260",
    "data-name": "Path 260",
    d: "M152.88,244.375c-5.579,0-10.412-3.748-10.679-3.959a1.6,1.6,0,0,1,1.981-2.514c.071.054,7.105,5.473,12.727,2.216,6.668-3.858,34.149-19.476,34.149-19.476l1.581,2.781s-27.462,15.608-34.126,19.464A11.06,11.06,0,0,1,152.88,244.375Z",
    transform: "translate(-141.593 -220.642)",
    fill: "#dfc4b7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11804",
    "data-name": "Group 11804",
    transform: "translate(59.359 35.512)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_261",
    "data-name": "Path 261",
    d: "M167.616,241.241c-7.2,0-15.4-7.973-16.475-9.042a1.6,1.6,0,0,1,2.264-2.262c2.993,2.99,11.819,10.171,16.627,7.526,6.812-3.748,25.14-15.329,25.324-15.447a1.6,1.6,0,0,1,1.713,2.706c-.756.477-18.6,11.749-25.493,15.544A8.1,8.1,0,0,1,167.616,241.241Z",
    transform: "translate(-150.674 -221.77)",
    fill: "#dfc4b7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11807",
    "data-name": "Group 11807",
    transform: "translate(0 107.271)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_262",
    "data-name": "Path 262",
    d: "M120.871,240.217s4.578-.7,6.857-1.324c2.5-.682,1.13,1.053.514,1.324a5.885,5.885,0,0,0-2.1,1.857c.289.92,1.452,2.94,2.041,4.383,1.533,3.751-1.139,5.477-3.8,3.9a59.839,59.839,0,0,1-7.088-4.97Z",
    transform: "translate(-60.733 -173.622)",
    fill: "#ffc5b3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11806",
    "data-name": "Group 11806",
    transform: "translate(0 2.159)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_263",
    "data-name": "Path 263",
    d: "M111.427,202.7c-.293-.091-3.611,3.715-5.564,7.815s-7.786-2.621-7.786-2.621l3.939-10.457Z",
    transform: "translate(-65.777 -186.621)",
    fill: "#ffc5b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_264",
    "data-name": "Path 264",
    d: "M108.342,189.131c7.42-2.5,9.744,13.694,6.032,19.252-3.416,5.113-12.9-.09-15.088-4.321S99.4,192.152,108.342,189.131Z",
    transform: "translate(-65.663 -188.87)",
    fill: "#ffc5b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_265",
    "data-name": "Path 265",
    d: "M103.316,300.845s7.9-3.524,11.816-3.693,4.289,4.424,0,7.985-7.574,4.036-11.083,5.479c-3.164,1.3-4.3,1.4-6.824-.235-3.367-2.183-.669-7.957-.669-7.957Z",
    transform: "translate(-66.445 -160.449)",
    fill: "#34324c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_266",
    "data-name": "Path 266",
    d: "M81.968,294.3s6.278-2.623,10.19-2.793,5.314,3.212,1.025,6.772-6.973,4.349-10.482,5.792c-3.164,1.3-4.282,1.376-6.824-.235-3.46-2.194-.755-7.968-.669-7.957Z",
    transform: "translate(-72.065 -161.93)",
    fill: "#34324c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_267",
    "data-name": "Path 267",
    d: "M104.992,205.275s-7.191-7.709-14.986-1.5c-7.166,5.709-14.065,16.361-12.226,21.73s7.867,8.671,7.867,8.671Z",
    transform: "translate(-71.183 -185.592)",
    fill: "#656c9a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_268",
    "data-name": "Path 268",
    d: "M107.652,245.937s6.546,25.827,8.195,34.725c1.069,5.77-.851,19.191-1.3,27.647-.245,4.585,1.944,5.2.7,8.079-.856,1.98-3.774,4.191-6.987,5.059-5.472,1.477-7.514.755-8.086-1.331-.423-1.549-1.827-4.1-1.191-7.228,1.115-5.472,0-7.124,0-11.886a97.224,97.224,0,0,1,1.8-15.611S92.382,265.7,91.62,264.31c1.156,7.494-.106,13.392-.549,18.34-.477,5.333-.164,10.736-1.242,17.935-.322,2.153-1.428,2.516-1.887,5.532-.274,1.788,1.887,3.736.225,4.924-2.813,2.009-12.653,6.358-14.852,2.377-1.809-3.274,1.131-3.168.712-6.417-.211-1.643-1.592-2.892-1.531-5.515.109-4.632,1.99-15.367,2.053-19.1.077-4.547,1-15.02,1.2-22.224.282-10.235,2.2-19.051,5.891-22.03C87.081,233.743,107.652,245.937,107.652,245.937Z",
    transform: "translate(-72.492 -176.19)",
    fill: "#656c9a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_269",
    "data-name": "Path 269",
    d: "M82.731,217.711c3.1-6,9.725-14.1,14.939-15.188,5.629-1.173,14.6,4.041,20.685,10.07S114.2,227.7,114.2,227.7a67.025,67.025,0,0,1-1.713,9.307c-.917,3.279-2.149,8.99-2.652,11.231-2.329,10.38-.412,15.656-.412,15.656s-12.085,6.555-18.234,4.694-16.459-9.464-17.073-11.383C74.679,251.422,76.569,229.642,82.731,217.711Z",
    transform: "translate(-72.065 -185.33)",
    fill: "#7d86b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_270",
    "data-name": "Path 270",
    d: "M109.164,209.754s.665-2.435,0-3.563c-1.492-2.53-5.719-3.434-7.771-4.352-4.352-1.947-5.868.971-5.753,1S109.164,209.754,109.164,209.754Z",
    transform: "translate(-66.418 -185.642)",
    fill: "#656c9a"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_271",
    "data-name": "Path 271",
    d: "M103.747,245.2a31.256,31.256,0,0,1-4.983,2.709c-2.3.9-5.152,2.248-5.152,2.248V247l10.3-4.728Z",
    transform: "translate(-66.949 -172.693)",
    fill: "#656c9a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_272",
    "data-name": "Path 272",
    d: "M110.456,210.061c3.318,1.812,5.515,5.31,4.8,10.538a111.948,111.948,0,0,0-.614,13.127s9.725,10.727,12,12.89c2.863,7.728-4.458,9.153-4.458,9.153s-11.977-6.811-14.632-9.153-5.778-3.084-5.778-10.451C101.774,232.243,103.125,206.058,110.456,210.061Z",
    transform: "translate(-64.806 -181.258)",
    fill: "#656c9a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_273",
    "data-name": "Path 273",
    d: "M113.142,189.319c-2.594-1.427-6.136-3.386-10.84-1.136-4.2,2.007-5.364,8.268-6.122,10.123a7.4,7.4,0,0,1-2.671,2.761,4.341,4.341,0,0,0,3.272-.929,15.627,15.627,0,0,0,.1,5.172c.1.824.845,4.09.845,4.09a10.94,10.94,0,0,1,2.716-2.343,22.24,22.24,0,0,0-.617,4.848,51.8,51.8,0,0,1,5.237-4.039,7.032,7.032,0,0,0,1.058,3.715c1.141-2.442,5.282-3.2,9.075-9.4C117.169,198.966,121.632,193.993,113.142,189.319Z",
    transform: "translate(-66.976 -187.16)",
    fill: "#23203a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11808",
    "data-name": "Group 11808",
    transform: "translate(27.061 96.396)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_274",
    "data-name": "Path 274",
    d: "M136,182.141s-28.121-3.743-40.386-2.463c-8.479.885,17.416,13.172,28.9,22.328,13.674,10.905,29.1,27.073,52.191,30.317,6.886.967,46.234,3.715,46.234,3.715l2.714-1.552A218.337,218.337,0,0,1,192.2,221.271C170.539,210.534,145.554,194.22,136,182.141Z",
    transform: "translate(-93.924 -178.319)",
    fill: "#ee0d09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275",
    "data-name": "Path 275",
    d: "M94.193,179.411s-.6,1.188,0,1.935,2.76-.369,2.76-.369Z",
    transform: "translate(-93.927 -178.319)",
    fill: "#ee0d09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276",
    "data-name": "Path 276",
    d: "M135.951,180.449S108.064,177.6,95.8,178.877c-8.479.885,17.182,12.28,28.662,21.436,13.674,10.905,29.1,27.074,52.191,30.319,6.886.967,48.948,4.083,48.948,4.083S158.855,209.4,135.951,180.449Z",
    transform: "translate(-93.878 -178.546)",
    fill: "#ee0d09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_277",
    "data-name": "Path 277",
    d: "M148.742,213.211s4.173,3.887,16.17,5.088,31.807,1.011,31.807,1.011l-12.3-5.435Z",
    transform: "translate(-79.539 -169.447)",
    fill: "#ee0d09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_278",
    "data-name": "Path 278",
    d: "M106.77,185.591s-3.056-4.744,5.789-4.439,23.074,1.9,23.074,1.9l5.205,5.267Z",
    transform: "translate(-90.69 -177.866)",
    fill: "#ee0d09"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11810",
    "data-name": "Group 11810",
    transform: "translate(275.401 72.046)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_279",
    "data-name": "Path 279",
    d: "M320.471,183.748c-.187.934.5,1.365,1.447,2.323.274.277-2.5.924-2.5.924l.872,5.2,6.36-2,2.52-3.589s-3.53.028-4.26-.889c-.38-.476-1.929-.924-2.846-1.264C321.217,184.137,320.554,183.333,320.471,183.748Z",
    transform: "translate(-283.078 -152.861)",
    fill: "#ffc5b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_280",
    "data-name": "Path 280",
    d: "M350.177,224.893a33,33,0,0,1,6.528.78c1.448.425,4.006,1.334,3.842,3.512-.222,2.935-.919,6.223-.737,10.729.05,1.268.178,2.867-3.44,4.1a7.7,7.7,0,0,1-7.6-1.557c-1.064-.982-2.639-3.439,2.275-4.22-.11-1.111.16-3.573-3.387-4.619C346.073,233.146,347.636,224.923,350.177,224.893Z",
    transform: "translate(-275.833 -142.031)",
    fill: "#23203a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_281",
    "data-name": "Path 281",
    d: "M335.863,233.415a33,33,0,0,1,6.528.779c1.447.427,4.006,1.336,3.842,3.514-.222,2.935-.919,6.223-.737,10.729.051,1.268.178,2.866-3.44,4.094a7.7,7.7,0,0,1-7.6-1.555c-1.064-.982-2.639-3.44,2.275-4.222-.11-1.111.16-3.572-3.387-4.618C331.759,241.667,333.322,233.445,335.863,233.415Z",
    transform: "translate(-279.591 -139.794)",
    fill: "#23203a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_282",
    "data-name": "Path 282",
    d: "M335.912,232.8c6.288,1.211,18.309,4.623,18.309,4.623s.172-4.715,1.375-7.421a8.855,8.855,0,0,1,3.253-3.419l-20.206-8.443-11.824,7.891S330.367,231.734,335.912,232.8Z",
    transform: "translate(-281.136 -143.803)",
    fill: "#656c9a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_283",
    "data-name": "Path 283",
    d: "M360.8,208.083,333.913,211.9s-8.027,6.2-15.5,12.73c-3.664,3.2-5.911,7.629-7.513,11.225-1.879,4.214,3.5,7.651,9.23,9.62,5.239,1.8,19.356,5.5,19.356,5.5s.03-4.779,1.923-7.329a25.349,25.349,0,0,1,3.887-4.058l-5.879-2.4c8.693-2.134,18.285-4.371,21.382-10.553C363.56,221.117,360.8,208.083,360.8,208.083Z",
    transform: "translate(-285.414 -146.443)",
    fill: "#656c9a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11809",
    "data-name": "Group 11809",
    transform: "translate(41.402)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_284",
    "data-name": "Path 284",
    d: "M339,178.176s6.695-.067,8.4,5.429a20.1,20.1,0,0,1,.554,9.988l-8.319-4.325Z",
    transform: "translate(-319.34 -154.293)",
    fill: "#656c9a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_285",
    "data-name": "Path 285",
    d: "M334.553,163.261c2.524-1.752,7.381-1.2,9.486,3.245,1.167,2.464-.482,9.09-.742,13.742a11.316,11.316,0,0,0,1.047,5.919l-3.218,1.327a9.713,9.713,0,0,1-6.573,0l.1-5.723s-3.466-.514-4.072-1.069c-1.459-1.34-2.232-5.319-1.555-10.453C330.036,162.605,333.622,163.907,334.553,163.261Z",
    transform: "translate(-322.023 -158.451)",
    fill: "#ffc5b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_286",
    "data-name": "Path 286",
    d: "M323.428,224.882c.345.308,5.709,11.282,18.964,11.864,5.749.253,12.285-5.2,16.082-7.2.48-5.459-.264-10.121-.082-14.45.608-14.443-2.3-23.346-4.594-27.878-2.852-5.627-6.1-7.5-6.1-7.5l-11.732,1.745a14.733,14.733,0,0,0-6.328,4.571c-1.781,2.3-6.295,7.624-4.4,11.678C327.428,202.377,325.693,219.073,323.428,224.882Z",
    transform: "translate(-323.428 -153.891)",
    fill: "#7d86b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_287",
    "data-name": "Path 287",
    d: "M333.407,181c1.961-.2,5.4.278,8.331-1.649,3.12-2.052,4.224.656,4.224.656a8.969,8.969,0,0,1-4.806,3.93c-3.27,1.04-7.917,1.823-11.136.235C330,182.053,332.035,181.135,333.407,181Z",
    transform: "translate(-321.698 -154.187)",
    fill: "#656c9a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_288",
    "data-name": "Path 288",
    d: "M327.436,162.973a5.956,5.956,0,0,0,3.991-.8c-.728-.212-1.4-1.264-1.846-2.141,4.1-1.488,12.254-.535,14.026.4,3.271,1.72,6.629,4.414,4.858,12.645-1.433,6.653-3.347,8.252-5.357,9.815-5.5-2.031-6.362-6.115-6.362-6.115s1.76-3.479.4-4.719c-1.451-1.322-2.935.779-3.275,1.627C331.63,171.97,327.436,168.36,327.436,162.973Z",
    transform: "translate(-322.376 -159.259)",
    fill: "#23203a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_289",
    "data-name": "Path 289",
    d: "M326.415,208.621a57.2,57.2,0,0,0,5.039,6.662,12.647,12.647,0,0,0,2.995,2.467l-2.185,2.371a28.343,28.343,0,0,1-3.471-3.91c-1.581-2.246-2.722-4.248-2.722-4.248Z",
    transform: "translate(-322.735 -146.302)",
    fill: "#656c9a"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_290",
    "data-name": "Path 290",
    d: "M300.875,198.9s-2.36-1.174-3.055-2.635-1.1-2.29-1.79-2.29-.8.915-.572,1.488,1.324,3.131.8,3.378a15.352,15.352,0,0,1-3.815.674,39.933,39.933,0,0,0-1.81,7.316,11.516,11.516,0,0,0,2.591.2c2.873-.115,9.162,0,9.162,0Z",
    transform: "translate(-290.634 -150.147)",
    fill: "#ffc5b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_291",
    "data-name": "Path 291",
    d: "M342.212,191.348c-.111-2.338-1-8.3-3.575-8.31-7.737-.032-11.8,12-18.631,15.022s-20.625,2.683-20.625,2.683-2.578,2.632-2.918,4.762a10.412,10.412,0,0,0,.735,5.963s19.762,2.728,26.6,0S342.878,205.423,342.212,191.348Z",
    transform: "translate(-289.14 -153.017)",
    fill: "#656c9a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11812",
    "data-name": "Group 11812",
    transform: "translate(79.618 173.168)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_292",
    "data-name": "Path 292",
    d: "M164.535,389.189c-4.436,0-9.587-1.454-15.781-5.271-5.449-3.358-8.358-7.37-8.643-11.927-.667-10.621,13.324-21.88,20.048-27.29,4.324-3.479,6.508-6.689,6.874-10.1.539-5.03-2.9-10.455-8.23-17.051-8.431-10.439-7.79-21.311-7.112-32.822.115-1.956.232-3.935.306-5.937.114-3.069.329-6.086.539-9,.439-6.15.819-11.46.106-15.1-.5-2.541-3.462-4.548-5.422-5.876l-.466-.317c-5.506-3.769-10.9-7.964-10.953-8.005a.632.632,0,0,1,.775-1c.054.043,5.417,4.214,10.891,7.963l.46.312c2.134,1.444,5.357,3.626,5.954,6.679.747,3.808.361,9.195-.086,15.434-.208,2.908-.424,5.913-.537,8.961-.073,2.012-.191,4-.307,5.965-.664,11.26-1.29,21.9,6.834,31.954,5.527,6.843,9.089,12.519,8.5,17.98-.4,3.766-2.735,7.247-7.338,10.951-6.559,5.276-20.2,16.258-19.58,26.226.259,4.123,2.966,7.8,8.045,10.931,16.156,9.957,24.543,3.366,32.654-3.006,1.636-1.285,3.329-2.615,5.034-3.753,9.836-6.571,16.445-10.241,16.511-10.277a.631.631,0,0,1,.611,1.1c-.066.035-6.632,3.683-16.42,10.222-1.665,1.112-3.264,2.367-4.957,3.7C177.743,384.84,172.206,389.189,164.535,389.189Z",
    transform: "translate(-135.557 -239.356)",
    fill: "#23203a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11818",
    "data-name": "Group 11818",
    transform: "translate(37.975 177.769)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11814",
    "data-name": "Group 11814",
    transform: "translate(0 5.086)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_293",
    "data-name": "Path 293",
    d: "M38.759,191.66l-.093-.053C38.7,191.628,38.729,191.64,38.759,191.66Z",
    transform: "translate(-37.911 -142.268)",
    fill: "#ea6f53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_294",
    "data-name": "Path 294",
    d: "M57.513,152.835l-16.847,9.727a6.242,6.242,0,0,0-2.6,4.964v30.468l8.7-7.44,7.608,3.359,3.133-1.809a6.246,6.246,0,0,0,2.6-4.964V154.8C60.111,152.895,58.942,152.011,57.513,152.835Z",
    transform: "translate(-38.068 -152.526)",
    fill: "#ff816c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_295",
    "data-name": "Path 295",
    d: "M38.74,193.313l12.208,6.993L58,186.986,54.2,185.309,40.49,193.226A1.62,1.62,0,0,1,38.74,193.313Z",
    transform: "translate(-37.892 -143.921)",
    fill: "#ce4132"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_296",
    "data-name": "Path 296",
    d: "M38.068,190.088v1.874a2.444,2.444,0,0,0,.755,2l.093.053a1.62,1.62,0,0,0,1.75-.087l13.713-7.917-7.608-3.359Z",
    transform: "translate(-38.068 -144.62)",
    fill: "#ce4132"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_297",
    "data-name": "Path 297",
    d: "M65.6,155.53l-11.823-6.806-1.195.87,11.553,6.559Z",
    transform: "translate(-34.26 -148.438)",
    fill: "#ea6f53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_298",
    "data-name": "Path 298",
    d: "M56.122,152.624l12.4,7.092-7.134,10.963-11.98-7.785Z",
    transform: "translate(-35.091 -147.415)",
    fill: "#ff816c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_299",
    "data-name": "Path 299",
    d: "M67.143,197.611,50.3,207.338c-1.429.824-2.6-.059-2.6-1.964V173.033a6.246,6.246,0,0,1,2.6-4.964l16.847-9.726c1.429-.826,2.6.058,2.6,1.963v32.341A6.242,6.242,0,0,1,67.143,197.611Z",
    transform: "translate(-35.54 -145.995)",
    fill: "#e05a44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_300",
    "data-name": "Path 300",
    d: "M66.414,159.967,64.5,154.945a1.341,1.341,0,0,0-2.137-.648l-2.348,1.382-.7,8.385Z",
    transform: "translate(-32.491 -147.05)",
    fill: "#e05a44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_301",
    "data-name": "Path 301",
    d: "M47.757,172.031c0-2.308,1.607-7.059,1.607-7.059a7.291,7.291,0,0,1,2.978-4.349l3.525-2.007.648,7.61S47.757,174.657,47.757,172.031Z",
    transform: "translate(-35.525 -145.842)",
    fill: "#e05a44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_302",
    "data-name": "Path 302",
    d: "M56.865,154.455l-1.916-5.023a1.341,1.341,0,0,0-2.136-.648l-2.349,1.384-.7,8.385Z",
    transform: "translate(-34.997 -148.498)",
    fill: "#ea6f53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_303",
    "data-name": "Path 303",
    d: "M38.1,166.81c0-2.308,1.749-7.35,1.749-7.35a7.284,7.284,0,0,1,2.977-4.349l3.525-2.007,3.947,6.96S38.1,169.436,38.1,166.81Z",
    transform: "translate(-38.061 -147.289)",
    fill: "#ff816c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_304",
    "data-name": "Path 304",
    d: "M62.374,157.068l-12.056-6.961,2.349-1.383,12.056,6.961Z",
    transform: "translate(-34.853 -148.438)",
    fill: "#ff8f80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_305",
    "data-name": "Path 305",
    d: "M50.428,149.82l-.526,6.328,12.052,7.013.531-6.38Z",
    transform: "translate(-34.962 -148.151)",
    fill: "#ea6f53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_306",
    "data-name": "Path 306",
    d: "M57.42,160.064,45.364,153.1l-3.524,2.007L53.9,162.071Z",
    transform: "translate(-37.078 -147.289)",
    fill: "#ff8f80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_307",
    "data-name": "Path 307",
    d: "M50.226,171.359l-12.158-6.952v32.341L50.226,203.7Z",
    transform: "translate(-38.068 -144.321)",
    fill: "#ea6f53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308",
    "data-name": "Path 308",
    d: "M57.123,157.536,54.1,159.274l-5.118-2.955,5.834-3.379Z",
    transform: "translate(-35.203 -147.332)",
    fill: "#ce4132"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309",
    "data-name": "Path 309",
    d: "M53.1,154.561a3.581,3.581,0,0,0,1.846,3.082c.986.4,1.757-.34,1.723-1.646a3.58,3.58,0,0,0-1.844-3.082C53.838,152.518,53.066,153.254,53.1,154.561Z",
    transform: "translate(-34.123 -147.366)",
    fill: "#ce4132"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11815",
    "data-name": "Group 11815",
    transform: "translate(15.469 20.648)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_310",
    "data-name": "Path 310",
    d: "M64.865,164.863c-.518-.1-1.187.525-1.486,1.386L56.9,184.893l2.971-2.772,5.395-15.512C65.56,165.747,65.381,164.962,64.865,164.863Z",
    transform: "translate(-48.595 -164.853)",
    fill: "#ce4132"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_311",
    "data-name": "Path 311",
    d: "M50.919,172.107c.52-.693,1.187-.836,1.482-.316l6.4,11.251-2.964.632-5.325-9.361A2.3,2.3,0,0,1,50.919,172.107Z",
    transform: "translate(-50.308 -163.114)",
    fill: "#ce4132"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_312",
    "data-name": "Path 312",
    d: "M64.792,187.363c-.52.694-1.187.836-1.483.317l-6.4-11.253,2.964-.631,5.325,9.361A2.3,2.3,0,0,1,64.792,187.363Z",
    transform: "translate(-48.592 -161.98)",
    fill: "#ce4132"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_313",
    "data-name": "Path 313",
    d: "M50.863,196.237c.518.1,1.187-.525,1.486-1.386l6.482-18.642-2.969,2.772-5.395,15.512C50.167,195.355,50.345,196.139,50.863,196.237Z",
    transform: "translate(-50.321 -161.872)",
    fill: "#ce4132"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_314",
    "data-name": "Path 314",
    d: "M61.1,181.4l-6.218,3.568c-.7.4-1.264-.033-1.261-.959l.013-4.351a3.037,3.037,0,0,1,1.27-2.411l6.218-3.568c.7-.4,1.264.033,1.261.959l-.011,4.351A3.036,3.036,0,0,1,61.1,181.4Z",
    transform: "translate(-49.455 -162.575)",
    fill: "#ce4132"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_315",
    "data-name": "Path 315",
    d: "M60,180.163l-4.553,2.612c-.436.25-.792-.02-.79-.6l.009-2.955a1.9,1.9,0,0,1,.8-1.51l4.553-2.612c.436-.25.79.02.789.6l-.008,2.955A1.905,1.905,0,0,1,60,180.163Z",
    transform: "translate(-49.183 -162.189)",
    fill: "#e05a44"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_316",
    "data-name": "Path 316",
    d: "M62.055,168.354l-8.288,4.785V171.71l8.288-4.785Z",
    transform: "translate(-33.947 -143.661)",
    fill: "#ce4132"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_317",
    "data-name": "Path 317",
    d: "M62.055,187.509l-8.288,4.785v-1.429l8.288-4.785Z",
    transform: "translate(-33.947 -138.633)",
    fill: "#ce4132"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_318",
    "data-name": "Path 318",
    d: "M62.055,185.237l-8.288,4.785v-1.429l8.288-4.785Z",
    transform: "translate(-33.947 -139.229)",
    fill: "#ce4132"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_319",
    "data-name": "Path 319",
    d: "M62.055,165.893l-8.288,4.785v-1.429l8.288-4.785Z",
    transform: "translate(-33.947 -144.307)",
    fill: "#ce4132"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_320",
    "data-name": "Path 320",
    d: "M47.491,187.208l-7.667-4.426V168.79l7.667,4.426Z",
    transform: "translate(-37.607 -143.171)",
    fill: "#34324c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321",
    "data-name": "Path 321",
    d: "M44.239,182.449l-3.285-1.9v-6l3.285,1.9Z",
    transform: "translate(-37.311 -141.657)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_322",
    "data-name": "Path 322",
    d: "M46.185,174.39l-5.466-3.179v-1.032l5.466,3.179Z",
    transform: "translate(-37.372 -142.807)",
    fill: "#dfc4b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_323",
    "data-name": "Path 323",
    d: "M46.185,176.072l-5.466-3.179v-1.032l5.466,3.179Z",
    transform: "translate(-37.372 -142.365)",
    fill: "#dfc4b7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11817",
    "data-name": "Group 11817",
    transform: "translate(2.489 12.138)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_324",
    "data-name": "Path 324",
    d: "M48.022,161.053a3.554,3.554,0,0,1-2.118,4.424,3.275,3.275,0,0,1-4.261-2.082,3.551,3.551,0,0,1,2.118-4.423A3.276,3.276,0,0,1,48.022,161.053Z",
    transform: "translate(-39.665 -157.939)",
    fill: "#44435e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_325",
    "data-name": "Path 325",
    d: "M42.006,164.708l1.163.672,3.537-5.926-1.4-.841Z",
    transform: "translate(-39.524 -157.98)",
    fill: "#44435e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_326",
    "data-name": "Path 326",
    d: "M47.273,160.614a3.551,3.551,0,0,1-2.117,4.422,3.275,3.275,0,0,1-4.262-2.081,3.554,3.554,0,0,1,2.118-4.424A3.275,3.275,0,0,1,47.273,160.614Z",
    transform: "translate(-39.862 -158.055)",
    fill: "#545470"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_327",
    "data-name": "Path 327",
    d: "M46.569,160.615a2.948,2.948,0,0,1-1.76,3.674,2.719,2.719,0,0,1-3.539-1.728,2.95,2.95,0,0,1,1.76-3.675A2.721,2.721,0,0,1,46.569,160.615Z",
    transform: "translate(-39.755 -157.953)",
    fill: "#23203a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328",
    "data-name": "Path 328",
    d: "M41.005,163.332l1.765.956,2.71-5.033-1.662-.929Z",
    transform: "translate(-39.786 -158.055)",
    fill: "#23203a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_329",
    "data-name": "Path 329",
    d: "M45.485,160.011a2.95,2.95,0,0,1-1.76,3.675,2.721,2.721,0,0,1-3.539-1.73,2.948,2.948,0,0,1,1.76-3.674A2.719,2.719,0,0,1,45.485,160.011Z",
    transform: "translate(-40.04 -158.112)",
    fill: "#34324c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11816",
    "data-name": "Group 11816",
    transform: "translate(0.613 0.633)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_330",
    "data-name": "Path 330",
    d: "M40.882,161.744a2.305,2.305,0,0,1,1.374-2.868,2.105,2.105,0,0,1,1.595.054,2.1,2.1,0,0,0-1.837-.187,2.3,2.3,0,0,0-1.374,2.868,2.138,2.138,0,0,0,1.169,1.3A2.146,2.146,0,0,1,40.882,161.744Z",
    transform: "translate(-40.526 -158.613)",
    fill: "#bf9b90"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_331",
    "data-name": "Path 331",
    d: "M43.353,162.934a2.3,2.3,0,0,0,1.374-2.868A2.136,2.136,0,0,0,43.8,158.9a2.105,2.105,0,0,0-1.595-.054,2.305,2.305,0,0,0-1.374,2.868,2.146,2.146,0,0,0,.927,1.163A2.105,2.105,0,0,0,43.353,162.934Z",
    transform: "translate(-40.475 -158.585)",
    fill: "#dfc4b7"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11823",
    "data-name": "Group 11823",
    transform: "translate(59.452 188.574)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11821",
    "data-name": "Group 11821"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_332",
    "data-name": "Path 332",
    d: "M76.271,157.074v6.475a2.837,2.837,0,0,1-1.18,2.255l-7.206,4.161c-.649.374-1.18-.028-1.18-.893v-6.61a9.2,9.2,0,0,0-2.849,6.232L57.1,172.6a4.844,4.844,0,0,0-2.02,3.864V209.1a3.536,3.536,0,0,0,5.3,3.063l15.309-8.839a6.1,6.1,0,0,0,3.056-5.287c0-8.615,0-30.055,0-30.07v-7.875C78.753,158.074,77.719,156.939,76.271,157.074Z",
    transform: "translate(-55.079 -157.054)",
    fill: "#bf9b90"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11819",
    "data-name": "Group 11819",
    transform: "translate(0.001 11.655)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_333",
    "data-name": "Path 333",
    d: "M57.1,169.478a4.848,4.848,0,0,0-2.02,3.864v7.016l8.86,4.224,6.266-8.24-12.322-7.317Z",
    transform: "translate(-55.08 -165.569)",
    fill: "#efd9d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_334",
    "data-name": "Path 334",
    d: "M63.273,166.288,57.3,169.743l12.322,7.317,4.048-5.042Z",
    transform: "translate(-54.497 -166.288)",
    fill: "#dfc4b7"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_335",
    "data-name": "Path 335",
    d: "M57.076,201.638l8.364,4.938V203l-9.961-5.421Z",
    transform: "translate(-54.975 -146.419)",
    fill: "#bf9b90"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_336",
    "data-name": "Path 336",
    d: "M83.38,169.259l-9.99-5.782-9.356,5.365,9.99,5.782Z",
    transform: "translate(-52.729 -155.37)",
    fill: "#dfc4b7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11820",
    "data-name": "Group 11820",
    transform: "translate(8.371)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_337",
    "data-name": "Path 337",
    d: "M73.252,166.263l-8.371-4.923-2.85,6.247,9.328,5.386Z",
    transform: "translate(-61.626 -155.931)",
    fill: "#bf9b90"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_338",
    "data-name": "Path 338",
    d: "M72.942,157.178l8.715,5.107-.52,8.479-9.547-5.515,1.783-3.291Z",
    transform: "translate(-59.117 -157.024)",
    fill: "#bf9b90"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_339",
    "data-name": "Path 339",
    d: "M71.865,157.076,80.235,162l1.35.317s-6.5-3.843-8.661-5.107A1.969,1.969,0,0,0,71.865,157.076Z",
    transform: "translate(-59.044 -157.056)",
    fill: "#efd9d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_340",
    "data-name": "Path 340",
    d: "M82.9,160.974l0,6.474a2.839,2.839,0,0,1-1.18,2.256l-7.206,4.16c-.649.375-1.18-.027-1.18-.893v-6.609a9.189,9.189,0,0,0-2.849,6.23L63.731,176.5a4.849,4.849,0,0,0-2.021,3.864V213a3.538,3.538,0,0,0,5.306,3.064l15.309-8.839a6.1,6.1,0,0,0,3.056-5.287c0-8.616,0-30.055,0-30.07v-7.875C85.384,161.974,84.35,160.838,82.9,160.974Z",
    transform: "translate(-61.71 -156.03)",
    fill: "#ceafa3"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_341",
    "data-name": "Path 341",
    d: "M81.333,197.988V171.656l-1.775.961L66,193.316V206.58c0,1.838,1.119,2.684,2.5,1.887l10.335-5.709A5.983,5.983,0,0,0,81.333,197.988Z",
    transform: "translate(-52.212 -153.224)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_342",
    "data-name": "Path 342",
    d: "M78.117,172.693,65.777,179.7V192Z",
    transform: "translate(-52.272 -152.951)",
    fill: "#34324c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_343",
    "data-name": "Path 343",
    d: "M63.451,179.264l-8.371-4.98v29.078l8.371,4.98Z",
    transform: "translate(-55.08 -152.534)",
    fill: "#dfc4b7"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_344",
    "data-name": "Path 344",
    d: "M64.411,161.34a2.663,2.663,0,0,0-.316.293c-.13.141-.274.318-.274.318l8.363,4.934.6-.621Z",
    transform: "translate(-52.785 -155.931)",
    fill: "#efd9d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_345",
    "data-name": "Path 345",
    d: "M77.372,163.227l-5.77,3.348-3.778-2.149,7.86-4.566Z",
    transform: "translate(-51.734 -156.32)",
    fill: "#ceafa3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_346",
    "data-name": "Path 346",
    d: "M73.679,161.047a2.622,2.622,0,0,0,1.352,2.259c.722.29,1.286-.25,1.262-1.206a2.625,2.625,0,0,0-1.352-2.259C74.22,159.551,73.654,160.09,73.679,161.047Z",
    transform: "translate(-50.198 -156.345)",
    fill: "#ceafa3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_347",
    "data-name": "Path 347",
    d: "M72.914,182s5.061,8.461,0,11.48S72.914,182,72.914,182Z",
    transform: "translate(-50.989 -150.509)",
    fill: "#34324c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_348",
    "data-name": "Path 348",
    d: "M79.427,192.853l-12.173,7.028V198.1l12.173-7.028Z",
    transform: "translate(-51.884 -148.127)",
    fill: "#34324c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11822",
    "data-name": "Group 11822",
    transform: "translate(6.543 10.255)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_349",
    "data-name": "Path 349",
    d: "M61.957,166.636V171.6a5.516,5.516,0,0,0,1.125.119v-5.085Z",
    transform: "translate(-59.817 -164.797)",
    fill: "#34324c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_350",
    "data-name": "Path 350",
    d: "M63.134,166.636V171.7a5.356,5.356,0,0,0,.943-.133v-4.933Z",
    transform: "translate(-59.508 -164.797)",
    fill: "#34324c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_351",
    "data-name": "Path 351",
    d: "M60.924,166.636V171.1a3.738,3.738,0,0,0,.943.412v-4.876Z",
    transform: "translate(-60.088 -164.797)",
    fill: "#34324c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_352",
    "data-name": "Path 352",
    d: "M64.167,166.636v4.821a3.343,3.343,0,0,0,.928-.466v-4.356Z",
    transform: "translate(-59.237 -164.797)",
    fill: "#34324c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_353",
    "data-name": "Path 353",
    d: "M65.5,166.636h-.316v4.025a1.221,1.221,0,0,0,.316-.778Z",
    transform: "translate(-58.969 -164.797)",
    fill: "#34324c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_354",
    "data-name": "Path 354",
    d: "M60.262,166.636v3.247a1.314,1.314,0,0,0,.475.942v-4.189Z",
    transform: "translate(-60.262 -164.797)",
    fill: "#34324c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_355",
    "data-name": "Path 355",
    d: "M60.638,166.636v4.189A2.488,2.488,0,0,0,61,171.1v-4.464Z",
    transform: "translate(-60.163 -164.797)",
    fill: "#23203a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_356",
    "data-name": "Path 356",
    d: "M61.671,166.636v4.876c.117.033.236.064.361.091v-4.967Z",
    transform: "translate(-59.892 -164.797)",
    fill: "#23203a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_357",
    "data-name": "Path 357",
    d: "M62.848,166.636v5.085h0c.122,0,.24-.013.359-.02v-5.065Z",
    transform: "translate(-59.583 -164.797)",
    fill: "#23203a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_358",
    "data-name": "Path 358",
    d: "M63.881,166.636v4.933c.126-.032.244-.071.361-.111v-4.821Z",
    transform: "translate(-59.312 -164.797)",
    fill: "#23203a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_359",
    "data-name": "Path 359",
    d: "M64.9,166.636v4.356a2.035,2.035,0,0,0,.361-.331v-4.025Z",
    transform: "translate(-59.044 -164.797)",
    fill: "#23203a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_360",
    "data-name": "Path 360",
    d: "M66.8,167.018c0,1.015-1.463,1.838-3.267,1.838s-3.267-.823-3.267-1.838,1.463-1.839,3.267-1.839S66.8,166,66.8,167.018Z",
    transform: "translate(-60.262 -165.179)",
    fill: "#44435e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_361",
    "data-name": "Path 361",
    d: "M65.959,166.933c0,.789-1.137,1.429-2.541,1.429s-2.54-.64-2.54-1.429,1.138-1.43,2.54-1.43S65.959,166.143,65.959,166.933Z",
    transform: "translate(-60.101 -165.094)",
    fill: "#34324c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11827",
    "data-name": "Group 11827",
    transform: "translate(451.409 219.225)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_362",
    "data-name": "Path 362",
    d: "M415.627,207.29c0,7.357-11.212,13.32-25.041,13.32s-25.041-5.964-25.041-13.32,11.212-13.319,25.041-13.319S415.627,199.934,415.627,207.29Z",
    transform: "translate(-365.544 -178.017)",
    fill: "#44435e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_363",
    "data-name": "Path 363",
    d: "M415.6,206.359c0,7.353-11.206,13.313-25.028,13.313s-25.026-5.96-25.026-13.313,11.2-13.312,25.026-13.312S415.6,199.007,415.6,206.359Z",
    transform: "translate(-365.544 -178.26)",
    fill: "#34324c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20",
    "data-name": "Rectangle 20",
    width: 50.053,
    height: 16.15,
    transform: "translate(0.001 12.761)",
    fill: "#34324c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_364",
    "data-name": "Path 364",
    d: "M415.6,194.647c0,7.351-11.206,13.312-25.028,13.312s-25.026-5.96-25.026-13.312,11.2-13.313,25.026-13.313S415.6,187.294,415.6,194.647Z",
    transform: "translate(-365.544 -181.334)",
    fill: "#44435e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_365",
    "data-name": "Path 365",
    d: "M412.958,193.967c0,6.708-10.222,12.145-22.832,12.145s-22.832-5.438-22.832-12.145,10.222-12.145,22.832-12.145S412.958,187.26,412.958,193.967Z",
    transform: "translate(-365.085 -181.206)",
    fill: "#575770"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11824",
    "data-name": "Group 11824",
    transform: "translate(8.529 3.986)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_366",
    "data-name": "Path 366",
    d: "M388.8,186.063c8.613,0,15.674,3.512,16.422,7.99a4.825,4.825,0,0,0,.075-.787c0-4.847-7.386-8.776-16.5-8.776s-16.5,3.929-16.5,8.776a4.825,4.825,0,0,0,.075.787C373.123,189.575,380.185,186.063,388.8,186.063Z",
    transform: "translate(-372.3 -184.491)",
    fill: "#44435e"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3",
    "data-name": "Ellipse 3",
    cx: 16.423,
    cy: 7.99,
    rx: 16.423,
    ry: 7.99,
    transform: "translate(0.074 1.572)",
    fill: "#23203a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11825",
    "data-name": "Group 11825",
    transform: "translate(0.015 24.149)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_367",
    "data-name": "Path 367",
    d: "M390.582,213.012c-13.338,0-24.208-5.555-24.954-12.55a7.28,7.28,0,0,0-.072.761c0,7.353,11.2,13.313,25.026,13.313s25.026-5.96,25.026-13.313a7.3,7.3,0,0,0-.072-.761C414.79,207.457,403.921,213.012,390.582,213.012Z",
    transform: "translate(-365.556 -200.462)",
    fill: "#44435e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11826",
    "data-name": "Group 11826",
    transform: "translate(0.015 18.633)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_368",
    "data-name": "Path 368",
    d: "M390.582,208.643c-13.338,0-24.208-5.555-24.954-12.55a7.313,7.313,0,0,0-.072.761c0,7.353,11.2,13.313,25.026,13.313s25.026-5.96,25.026-13.313a7.329,7.329,0,0,0-.072-.761C414.79,203.088,403.921,208.643,390.582,208.643Z",
    transform: "translate(-365.556 -196.093)",
    fill: "#44435e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11831",
    "data-name": "Group 11831",
    transform: "translate(255.983 41.371)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_369",
    "data-name": "Path 369",
    d: "M260.832,66.416c0,7.356-11.212,13.319-25.041,13.319s-25.041-5.963-25.041-13.319S221.96,53.1,235.79,53.1,260.832,59.059,260.832,66.416Z",
    transform: "translate(-210.749 -37.141)",
    fill: "#44435e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_370",
    "data-name": "Path 370",
    d: "M260.8,65.484c0,7.351-11.206,13.312-25.028,13.312s-25.026-5.96-25.026-13.312,11.2-13.313,25.026-13.313S260.8,58.131,260.8,65.484Z",
    transform: "translate(-210.749 -37.383)",
    fill: "#34324c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_21",
    "data-name": "Rectangle 21",
    width: 50.053,
    height: 16.15,
    transform: "translate(0 12.761)",
    fill: "#34324c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_371",
    "data-name": "Path 371",
    d: "M260.8,53.771c0,7.351-11.206,13.312-25.028,13.312s-25.026-5.96-25.026-13.312,11.2-13.313,25.026-13.313S260.8,46.418,260.8,53.771Z",
    transform: "translate(-210.749 -40.458)",
    fill: "#44435e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_372",
    "data-name": "Path 372",
    d: "M258.163,53.091c0,6.708-10.222,12.145-22.832,12.145S212.5,59.8,212.5,53.091s10.222-12.145,22.832-12.145S258.163,46.384,258.163,53.091Z",
    transform: "translate(-210.29 -40.33)",
    fill: "#575770"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11828",
    "data-name": "Group 11828",
    transform: "translate(8.528 3.986)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_373",
    "data-name": "Path 373",
    d: "M234,45.187c8.613,0,15.675,3.512,16.424,7.99a4.815,4.815,0,0,0,.075-.787c0-4.847-7.387-8.776-16.5-8.776s-16.5,3.929-16.5,8.776a4.693,4.693,0,0,0,.076.787C218.327,48.7,225.389,45.187,234,45.187Z",
    transform: "translate(-217.504 -43.615)",
    fill: "#44435e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_374",
    "data-name": "Path 374",
    d: "M233.986,60.839c8.613,0,15.675-3.511,16.424-7.989-.749-4.478-7.811-7.99-16.424-7.99s-15.675,3.512-16.422,7.99C218.311,57.328,225.374,60.839,233.986,60.839Z",
    transform: "translate(-217.488 -43.288)",
    fill: "#23203a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11829",
    "data-name": "Group 11829",
    transform: "translate(0.015 24.149)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_375",
    "data-name": "Path 375",
    d: "M235.787,72.136c-13.338,0-24.208-5.555-24.954-12.55a7,7,0,0,0-.072.761c0,7.353,11.2,13.313,25.026,13.313s25.026-5.96,25.026-13.313a7.322,7.322,0,0,0-.072-.761C260,66.581,249.125,72.136,235.787,72.136Z",
    transform: "translate(-210.761 -59.586)",
    fill: "#44435e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11830",
    "data-name": "Group 11830",
    transform: "translate(0.015 18.633)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_376",
    "data-name": "Path 376",
    d: "M235.787,67.769c-13.338,0-24.208-5.556-24.954-12.552a6.988,6.988,0,0,0-.072.763c0,7.351,11.2,13.312,25.026,13.312s25.026-5.96,25.026-13.312a7.313,7.313,0,0,0-.072-.763C260,62.212,249.125,67.769,235.787,67.769Z",
    transform: "translate(-210.761 -55.217)",
    fill: "#44435e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11835",
    "data-name": "Group 11835",
    transform: "translate(226.939 71.119)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_377",
    "data-name": "Path 377",
    d: "M237.826,89.978c0,7.357-11.211,13.321-25.041,13.321s-25.04-5.964-25.04-13.321,11.211-13.321,25.04-13.321S237.826,82.621,237.826,89.978Z",
    transform: "translate(-187.744 -60.704)",
    fill: "#44435e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_378",
    "data-name": "Path 378",
    d: "M237.8,89.046c0,7.353-11.2,13.313-25.026,13.313s-25.026-5.96-25.026-13.313,11.2-13.312,25.026-13.312S237.8,81.694,237.8,89.046Z",
    transform: "translate(-187.744 -60.947)",
    fill: "#34324c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22",
    "data-name": "Rectangle 22",
    width: 50.053,
    height: 16.15,
    transform: "translate(0 12.761)",
    fill: "#34324c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_379",
    "data-name": "Path 379",
    d: "M237.8,77.333c0,7.353-11.2,13.313-25.026,13.313s-25.026-5.96-25.026-13.313,11.2-13.312,25.026-13.312S237.8,69.981,237.8,77.333Z",
    transform: "translate(-187.744 -64.021)",
    fill: "#44435e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_380",
    "data-name": "Path 380",
    d: "M235.158,76.654c0,6.708-10.222,12.145-22.833,12.145s-22.832-5.438-22.832-12.145,10.222-12.145,22.832-12.145S235.158,69.947,235.158,76.654Z",
    transform: "translate(-187.285 -63.893)",
    fill: "#575770"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11832",
    "data-name": "Group 11832",
    transform: "translate(8.528 3.986)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_381",
    "data-name": "Path 381",
    d: "M211,68.75c8.613,0,15.675,3.512,16.424,7.989a4.8,4.8,0,0,0,.074-.785c0-4.847-7.387-8.776-16.5-8.776s-16.5,3.929-16.5,8.776a4.8,4.8,0,0,0,.074.785C195.322,72.262,202.384,68.75,211,68.75Z",
    transform: "translate(-194.499 -67.178)",
    fill: "#44435e"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_4",
    "data-name": "Ellipse 4",
    cx: 16.423,
    cy: 7.99,
    rx: 16.423,
    ry: 7.99,
    transform: "translate(0.075 1.571)",
    fill: "#23203a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11833",
    "data-name": "Group 11833",
    transform: "translate(0.014 24.149)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_382",
    "data-name": "Path 382",
    d: "M212.781,95.7c-13.337,0-24.207-5.555-24.953-12.55a6.937,6.937,0,0,0-.073.761c0,7.351,11.206,13.312,25.026,13.312s25.027-5.96,25.027-13.312a6.937,6.937,0,0,0-.073-.761C236.991,90.144,226.121,95.7,212.781,95.7Z",
    transform: "translate(-187.755 -83.149)",
    fill: "#44435e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11834",
    "data-name": "Group 11834",
    transform: "translate(0.014 18.633)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_383",
    "data-name": "Path 383",
    d: "M212.781,91.33c-13.337,0-24.207-5.555-24.953-12.55a6.967,6.967,0,0,0-.073.761c0,7.353,11.206,13.312,25.026,13.312s25.027-5.959,25.027-13.312a6.967,6.967,0,0,0-.073-.761C236.991,85.775,226.121,91.33,212.781,91.33Z",
    transform: "translate(-187.755 -78.78)",
    fill: "#44435e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11846",
    "data-name": "Group 11846",
    transform: "translate(441.251 269.907)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11836",
    "data-name": "Group 11836",
    transform: "translate(43.795 1.316)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_384",
    "data-name": "Path 384",
    d: "M394.5,274.509a10.144,10.144,0,0,1-2.314-.192l.625-2.054-.313,1.026.308-1.028c1.057.283,10.094.645,18.9-5.98,9.168-6.9,9.153-26.14,7.131-32.834-3.152-10.424-9.673-8.744-9.947-8.666l-.6-2.062c.087-.029,8.81-2.418,12.6,10.107,2.444,8.082,1.872,27.821-7.894,35.168A31.511,31.511,0,0,1,394.5,274.509Z",
    transform: "translate(-392.187 -222.52)",
    fill: "#34324c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11837",
    "data-name": "Group 11837",
    transform: "translate(49.74 58.79)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_385",
    "data-name": "Path 385",
    d: "M405.51,271.819c0,3.171-1.928,6.857-4.308,8.23s-4.306-.085-4.306-3.256,1.928-6.858,4.306-8.23S405.51,268.646,405.51,271.819Z",
    transform: "translate(-396.896 -268.045)",
    fill: "#44435e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_386",
    "data-name": "Path 386",
    d: "M406.457,269.934l-2.985-1.762-5.388,12.073,2.908,1.7Z",
    transform: "translate(-396.584 -268.012)",
    fill: "#44435e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_387",
    "data-name": "Path 387",
    d: "M407.892,273.212c0,3.173-1.928,6.857-4.306,8.23s-4.308-.085-4.308-3.256,1.928-6.857,4.308-8.23S407.892,270.041,407.892,273.212Z",
    transform: "translate(-396.271 -267.679)",
    fill: "#575770"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_388",
    "data-name": "Path 388",
    d: "M406.429,273.546a7.416,7.416,0,0,1-3.1,5.916c-1.711.987-3.1-.061-3.1-2.341a7.414,7.414,0,0,1,3.1-5.916C405.043,270.218,406.429,271.266,406.429,273.546Z",
    transform: "translate(-396.019 -267.314)",
    fill: "#ceafa3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11838",
    "data-name": "Group 11838",
    transform: "translate(32.903 76.055)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_389",
    "data-name": "Path 389",
    d: "M387.021,283.236a4.145,4.145,0,0,1-1.73,3.305c-.956.552-1.731-.034-1.731-1.308a4.143,4.143,0,0,1,1.731-3.305C386.245,281.376,387.021,281.962,387.021,283.236Z",
    transform: "translate(-383.56 -281.721)",
    fill: "#44435e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_390",
    "data-name": "Path 390",
    d: "M387.4,282.479l-1.2-.707-2.164,4.849,1.168.683Z",
    transform: "translate(-383.435 -281.707)",
    fill: "#44435e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_391",
    "data-name": "Path 391",
    d: "M387.976,283.8a4.142,4.142,0,0,1-1.73,3.305c-.954.552-1.73-.034-1.73-1.308a4.145,4.145,0,0,1,1.73-3.305C387.2,281.936,387.976,282.522,387.976,283.8Z",
    transform: "translate(-383.309 -281.574)",
    fill: "#575770"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23",
    "data-name": "Rectangle 23",
    width: 3.977,
    height: 3.208,
    transform: "translate(3.709 60.695)",
    fill: "#34324c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11839",
    "data-name": "Group 11839",
    transform: "translate(3.709 48.021)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_392",
    "data-name": "Path 392",
    d: "M413.309,271.284a7.292,7.292,0,0,1,1.951-.576v-3.46l-8.906-.357v3.467l-18.389-10.626a1.6,1.6,0,0,0-1.6-.005l-25.124,14.346a1.6,1.6,0,0,0-.008,2.78l26.641,15.395a1.6,1.6,0,0,0,1.6,0l18.965-10.956c0-.11-.013-.215-.013-.328C408.433,277.04,410.366,272.983,413.309,271.284Z",
    transform: "translate(-360.436 -259.515)",
    fill: "#34324c"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_393",
    "data-name": "Path 393",
    d: "M361.236,275.19l26.641,15.393a1.6,1.6,0,0,0,1.6,0l24.977-20.015c1.039-.865,1.069-2.159,0-2.776l-26.495-15.311a1.6,1.6,0,0,0-1.6,0L361.244,272.41A1.6,1.6,0,0,0,361.236,275.19Z",
    transform: "translate(-356.727 -213.397)",
    fill: "#575770"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_394",
    "data-name": "Path 394",
    d: "M398.454,274.076c0,3.967-6.046,7.184-13.5,7.184s-13.5-3.217-13.5-7.184,6.045-7.184,13.5-7.184S398.454,270.108,398.454,274.076Z",
    transform: "translate(-353.836 -209.558)",
    fill: "#575770"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_5",
    "data-name": "Ellipse 5",
    cx: 13.813,
    cy: 9.074,
    rx: 13.813,
    ry: 9.074,
    transform: "translate(15.454 52.268) rotate(-15.041)",
    fill: "#dfc4b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_395",
    "data-name": "Path 395",
    d: "M398.455,249.887H371.447V273.8l27.008-4.382Z",
    transform: "translate(-353.837 -214.021)",
    fill: "#dfc4b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_396",
    "data-name": "Path 396",
    d: "M373.125,255.65l-1.8,1.074,5.025,2.947,2.038-1.191Z",
    transform: "translate(-353.869 -212.509)",
    fill: "#575770"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_397",
    "data-name": "Path 397",
    d: "M398.454,249.741a4.258,4.258,0,0,1-.744,2.344c-1.823-2.82-6.84-4.849-12.76-4.849s-10.937,2.029-12.761,4.849a4.257,4.257,0,0,1-.742-2.344v4.4h.025c-.006.091-.025.181-.025.274,0,3.967,6.045,7.182,13.5,7.182s13.5-3.216,13.5-7.182c0-.093-.019-.183-.025-.274h.025Z",
    transform: "translate(-353.836 -214.717)",
    fill: "#dfc4b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_398",
    "data-name": "Path 398",
    d: "M398.454,246.7a4.254,4.254,0,0,1-.744,2.343c-1.823-2.819-6.84-4.848-12.76-4.848s-10.937,2.029-12.761,4.848a4.253,4.253,0,0,1-.742-2.343v4.4h.025c-.006.092-.025.182-.025.274,0,3.968,6.045,7.184,13.5,7.184s13.5-3.216,13.5-7.184c0-.092-.019-.182-.025-.274h.025Z",
    transform: "translate(-353.836 -215.515)",
    fill: "#575770"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_399",
    "data-name": "Path 399",
    d: "M385.577,234.081h-1.252a12.916,12.916,0,0,0-12.877,12.879v2.4c0,1.661,1.071,3.186,2.851,4.4a21.809,21.809,0,0,0,21.306,0c1.78-1.217,2.851-2.742,2.851-4.4v-2.4A12.916,12.916,0,0,0,385.577,234.081Z",
    transform: "translate(-353.836 -218.17)",
    fill: "#34324c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_400",
    "data-name": "Path 400",
    d: "M383.83,278.488c.146.3-.095.713-.538.932s-.92.155-1.067-.14.095-.713.538-.932S383.684,278.192,383.83,278.488Z",
    transform: "translate(-351.019 -206.585)",
    fill: "#34324c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_401",
    "data-name": "Path 401",
    d: "M399.927,265.083c.146.3-.095.713-.538.932s-.922.156-1.067-.14.095-.713.538-.932S399.781,264.787,399.927,265.083Z",
    transform: "translate(-346.793 -210.104)",
    fill: "#34324c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_402",
    "data-name": "Path 402",
    d: "M366.224,268.316c.146.3-.095.713-.538.932s-.922.155-1.067-.14.095-.713.538-.933S366.077,268.02,366.224,268.316Z",
    transform: "translate(-355.64 -209.255)",
    fill: "#34324c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_403",
    "data-name": "Path 403",
    d: "M371.814,262.483l5,2.947-.46-5.982-5.025-2.947Z",
    transform: "translate(-353.869 -212.285)",
    fill: "#34324c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_404",
    "data-name": "Path 404",
    d: "M377.39,257.862l-2.084,1.228.46,5.982,1.624-.858Z",
    transform: "translate(-352.824 -211.928)",
    fill: "#34324c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11840",
    "data-name": "Group 11840",
    transform: "translate(0 44.579)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_405",
    "data-name": "Path 405",
    d: "M377.93,260.205a1.076,1.076,0,0,0-1.451.448c-.04.078-4.1,7.694-8.695,9.911-2.953,1.424-5.771,1.618-7.178.49-1.153-.92-1.062-2.558-.781-3.77,1.99-8.619,15.33-8.348,15.334-8.348-.051-.557-.174-2.146-.174-2.146-.645,0-14.862-.34-17.252,10.013-.8,3.454.619,5.2,1.533,5.929a6.113,6.113,0,0,0,3.873,1.187,13.114,13.114,0,0,0,5.579-1.422c5.236-2.525,9.483-10.5,9.661-10.842A1.074,1.074,0,0,0,377.93,260.205Z",
    transform: "translate(-357.498 -256.789)",
    fill: "#23203a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11841",
    "data-name": "Group 11841",
    transform: "translate(30.308 1.324)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_406",
    "data-name": "Path 406",
    d: "M399.753,278.056a1.073,1.073,0,0,1-1.073-1.073V246.294c0-6.145,1.649-8.8,5.113-12.121.689-.66,1.013-1.216.96-1.655-.153-1.262-3.067-2.942-6.44-4.885-.847-.487-1.747-1.006-2.693-1.567-3.012-1.788-4.954-2.154-7.843.588-3.736,3.55-4.161,5.916-4.126,10.48-.864-.021-1.341-.021-2.146-.02-.025-4.81.489-7.925,4.794-12.015,3.8-3.6,6.908-2.961,10.416-.879.937.556,1.831,1.069,2.669,1.553,4.347,2.5,7.219,4.159,7.5,6.487a4.131,4.131,0,0,1-1.607,3.464c-3.137,3-4.45,5.137-4.45,10.57v30.689A1.072,1.072,0,0,1,399.753,278.056Z",
    transform: "translate(-381.504 -222.527)",
    fill: "#ceafa3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11842",
    "data-name": "Group 11842",
    transform: "translate(59.303)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_407",
    "data-name": "Path 407",
    d: "M405.183,222.737a3.442,3.442,0,0,0,1.438,2.747c.794.458,1.438-.028,1.438-1.087a3.442,3.442,0,0,0-1.438-2.746C405.827,221.193,405.183,221.679,405.183,222.737Z",
    transform: "translate(-404.284 -221.478)",
    fill: "#bf9e94"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_408",
    "data-name": "Path 408",
    d: "M404.886,222.116l.914-.575,1.837,4-.938.586Z",
    transform: "translate(-404.362 -221.462)",
    fill: "#bf9e94"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_409",
    "data-name": "Path 409",
    d: "M404.471,223.18a3.443,3.443,0,0,0,1.438,2.747c.793.458,1.437-.029,1.437-1.087a3.445,3.445,0,0,0-1.437-2.747C405.115,221.635,404.471,222.122,404.471,223.18Z",
    transform: "translate(-404.471 -221.362)",
    fill: "#ceafa3"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_410",
    "data-name": "Path 410",
    d: "M399.039,231.351a12.066,12.066,0,0,0-4.518,4.984c-.163.3-1.611,3.341-2.125,4.632h0L371.9,287.1a.95.95,0,0,0,.492,1.257h0a.948.948,0,0,0,1.242-.487l21.453-48.324c1.228-2.668,2.429-4.621,3.952-5.5l15.587-9c.14-.081.481-.4.191-1.381-.178-.6-.808-.958-1.14-.766Z",
    transform: "translate(-353.739 -221.119)",
    fill: "#23203a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11844",
    "data-name": "Group 11844",
    transform: "translate(4.089 65.404)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_411",
    "data-name": "Path 411",
    d: "M376.244,280.567s.2-.954.266-1.4c.115-.73-.891-1.53-.891-1.53l-.894,1.334Z",
    transform: "translate(-357.065 -272.141)",
    fill: "#ceafa3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11843",
    "data-name": "Group 11843",
    transform: "translate(0 1.039)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_412",
    "data-name": "Path 412",
    d: "M379.223,280.489l-11.044-6.382-6.7,6.09,15.814,9.078Z",
    transform: "translate(-360.541 -274.107)",
    fill: "#ceafa3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_413",
    "data-name": "Path 413",
    d: "M361.677,278.931l-.94,1.182,16.1,9.64.652-1.744Z",
    transform: "translate(-360.737 -272.841)",
    fill: "#34324c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_414",
    "data-name": "Path 414",
    d: "M375.935,279.162l.5,1.005-1.868,8.586-.557-.8Z",
    transform: "translate(-357.253 -272.78)",
    fill: "#bf9e94"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_415",
    "data-name": "Path 415",
    d: "M374.143,286.122l-.652,1.743.652.711.557-1.65Z",
    transform: "translate(-357.389 -270.953)",
    fill: "#34324c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_416",
    "data-name": "Path 416",
    d: "M360.737,279.868l.6.715,16.151,9.635-.652-.711Z",
    transform: "translate(-360.737 -272.595)",
    fill: "#575770"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_417",
    "data-name": "Path 417",
    d: "M366.786,274.323,377.83,280.7s.388-1.264,0-1.8a24.156,24.156,0,0,0-3.055-1.914c-.649-.447.1-2.171.1-2.171l-1.682-.893s-.763,1.2-1.343,1.2-3.606-1.956-3.858-1.837A5.823,5.823,0,0,0,366.786,274.323Z",
    transform: "translate(-359.149 -273.284)",
    fill: "#efd9d0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11845",
    "data-name": "Group 11845",
    transform: "translate(25.66 17.544)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_418",
    "data-name": "Path 418",
    d: "M383.277,237.29c2.377,0,4.38.816,5.126,1.944a1.742,1.742,0,0,0,.328-.958c0-1.6-2.442-2.9-5.454-2.9s-5.454,1.3-5.454,2.9a1.741,1.741,0,0,0,.328.958C378.9,238.106,380.9,237.29,383.277,237.29Z",
    transform: "translate(-377.823 -235.375)",
    fill: "#23203a"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_6",
    "data-name": "Ellipse 6",
    cx: 5.126,
    cy: 1.944,
    rx: 5.126,
    ry: 1.944,
    transform: "translate(0.328 1.916)",
    fill: "#575770"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_419",
    "data-name": "Path 419",
    d: "M372.672,247.065a1.487,1.487,0,0,0,.622,1.188c.343.2.621-.011.621-.47a1.49,1.49,0,0,0-.621-1.189C372.95,246.4,372.672,246.607,372.672,247.065Z",
    transform: "translate(-353.515 -214.905)",
    fill: "#dfc4b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_420",
    "data-name": "Path 420",
    d: "M374.394,248.1a1.491,1.491,0,0,0,.622,1.188c.343.2.622-.011.622-.47a1.491,1.491,0,0,0-.622-1.189C374.673,247.432,374.394,247.643,374.394,248.1Z",
    transform: "translate(-353.063 -214.633)",
    fill: "#dfc4b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_421",
    "data-name": "Path 421",
    d: "M392.349,256.083,387.99,258.6v-1.226l4.358-2.516Z",
    transform: "translate(-349.494 -212.717)",
    fill: "#34324c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_422",
    "data-name": "Path 422",
    d: "M392.349,257.883,387.99,260.4v-1.226l4.358-2.516Z",
    transform: "translate(-349.494 -212.245)",
    fill: "#34324c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_423",
    "data-name": "Path 423",
    d: "M392.349,259.562l-4.358,2.516v-1.226l4.358-2.516Z",
    transform: "translate(-349.494 -211.804)",
    fill: "#34324c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_424",
    "data-name": "Path 424",
    d: "M392.349,261.362l-4.358,2.516v-1.226l4.358-2.516Z",
    transform: "translate(-349.494 -211.331)",
    fill: "#34324c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11860",
    "data-name": "Group 11860",
    transform: "translate(218.452 333.691)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11852",
    "data-name": "Group 11852",
    transform: "translate(0 14.749)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11847",
    "data-name": "Group 11847",
    transform: "translate(25.283 102.288)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_425",
    "data-name": "Path 425",
    d: "M203.161,368.787a7.908,7.908,0,0,0,3.3,6.31c1.823,1.053,3.3-.066,3.3-2.5a7.911,7.911,0,0,0-3.3-6.31C204.639,365.239,203.161,366.356,203.161,368.787Z",
    transform: "translate(-200.492 -364.393)",
    fill: "#23203a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_426",
    "data-name": "Path 426",
    d: "M202.172,367.5l2.548-1.5,4.155,9.236-2.653,1.529Z",
    transform: "translate(-200.752 -364.363)",
    fill: "#23203a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_427",
    "data-name": "Path 427",
    d: "M201.047,370.008a7.908,7.908,0,0,0,3.3,6.31c1.823,1.053,3.3-.064,3.3-2.5a7.911,7.911,0,0,0-3.3-6.31C202.525,366.459,201.047,367.577,201.047,370.008Z",
    transform: "translate(-201.047 -364.072)",
    fill: "#34324c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_428",
    "data-name": "Path 428",
    d: "M202.172,370.46a3.977,3.977,0,0,0,1.663,3.176c.918.53,1.663-.032,1.663-1.256a3.985,3.985,0,0,0-1.663-3.178C202.916,368.673,202.172,369.235,202.172,370.46Z",
    transform: "translate(-200.752 -363.577)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_429",
    "data-name": "Path 429",
    d: "M207.488,366.714v5.436a21.328,21.328,0,0,1-2.78,1.154c-1.494.491-2.1-.875-1.624-2.7a55.8,55.8,0,0,1,1.821-5.388Z",
    transform: "translate(-200.553 -364.571)",
    fill: "#ceafa3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_430",
    "data-name": "Path 430",
    d: "M206.54,366.72l2.69-1.527v5.433l-2.69,1.53Z",
    transform: "translate(-199.605 -364.577)",
    fill: "#dfc4b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_431",
    "data-name": "Path 431",
    d: "M209.17,364.728l-2.093,1.208-2.093-1.231-.49.643,2.583,1.5,2.69-1.527Z",
    transform: "translate(-200.142 -364.705)",
    fill: "#efd9d0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11848",
    "data-name": "Group 11848",
    transform: "translate(81.143 70.15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_432",
    "data-name": "Path 432",
    d: "M247.406,343.331a7.9,7.9,0,0,0,3.3,6.309c1.823,1.053,3.3-.064,3.3-2.5a7.908,7.908,0,0,0-3.3-6.309C248.884,339.782,247.406,340.9,247.406,343.331Z",
    transform: "translate(-244.738 -338.936)",
    fill: "#23203a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_433",
    "data-name": "Path 433",
    d: "M246.417,342.048l2.548-1.5,4.155,9.236-2.653,1.529Z",
    transform: "translate(-244.998 -338.906)",
    fill: "#23203a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_434",
    "data-name": "Path 434",
    d: "M245.293,344.552a7.908,7.908,0,0,0,3.3,6.309c1.824,1.053,3.3-.064,3.3-2.5a7.906,7.906,0,0,0-3.3-6.309C246.771,341,245.293,342.121,245.293,344.552Z",
    transform: "translate(-245.293 -338.616)",
    fill: "#34324c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_435",
    "data-name": "Path 435",
    d: "M246.417,345a3.979,3.979,0,0,0,1.663,3.176c.918.53,1.663-.033,1.663-1.256a3.984,3.984,0,0,0-1.663-3.178C247.161,343.216,246.417,343.779,246.417,345Z",
    transform: "translate(-244.998 -338.12)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_436",
    "data-name": "Path 436",
    d: "M251.733,341.258v5.436a21.539,21.539,0,0,1-2.78,1.154c-1.494.491-2.1-.875-1.622-2.7a55.411,55.411,0,0,1,1.821-5.388Z",
    transform: "translate(-244.8 -339.115)",
    fill: "#ceafa3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_437",
    "data-name": "Path 437",
    d: "M250.785,341.263l2.69-1.527v5.433l-2.69,1.53Z",
    transform: "translate(-243.851 -339.121)",
    fill: "#dfc4b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_438",
    "data-name": "Path 438",
    d: "M253.415,339.272l-2.093,1.208-2.093-1.231-.49.643,2.583,1.5,2.69-1.527Z",
    transform: "translate(-244.388 -339.249)",
    fill: "#efd9d0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11849",
    "data-name": "Group 11849",
    transform: "translate(0 87.474)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_439",
    "data-name": "Path 439",
    d: "M183.135,357.055a7.908,7.908,0,0,0,3.3,6.309c1.823,1.053,3.3-.064,3.3-2.5a7.91,7.91,0,0,0-3.3-6.31C184.613,353.5,183.135,354.623,183.135,357.055Z",
    transform: "translate(-180.466 -352.659)",
    fill: "#23203a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_440",
    "data-name": "Path 440",
    d: "M182.145,355.771l2.548-1.5,4.155,9.236-2.653,1.529Z",
    transform: "translate(-180.726 -352.629)",
    fill: "#23203a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_441",
    "data-name": "Path 441",
    d: "M181.021,358.275a7.908,7.908,0,0,0,3.3,6.309c1.824,1.053,3.3-.064,3.3-2.5a7.908,7.908,0,0,0-3.3-6.31C182.5,354.727,181.021,355.844,181.021,358.275Z",
    transform: "translate(-181.021 -352.338)",
    fill: "#34324c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_442",
    "data-name": "Path 442",
    d: "M182.145,358.726a3.984,3.984,0,0,0,1.663,3.178c.918.53,1.663-.033,1.663-1.257a3.982,3.982,0,0,0-1.663-3.176C182.89,356.939,182.145,357.5,182.145,358.726Z",
    transform: "translate(-180.726 -351.843)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_443",
    "data-name": "Path 443",
    d: "M187.461,354.981v5.436a21.54,21.54,0,0,1-2.78,1.154c-1.492.49-2.1-.876-1.622-2.7a55.363,55.363,0,0,1,1.821-5.39Z",
    transform: "translate(-180.528 -352.838)",
    fill: "#ceafa3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_444",
    "data-name": "Path 444",
    d: "M186.513,354.986l2.691-1.527v5.433l-2.691,1.53Z",
    transform: "translate(-179.579 -352.843)",
    fill: "#dfc4b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_445",
    "data-name": "Path 445",
    d: "M189.143,352.995,187.05,354.2l-2.093-1.231-.49.643,2.583,1.5,2.691-1.527Z",
    transform: "translate(-180.116 -352.971)",
    fill: "#efd9d0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11850",
    "data-name": "Group 11850",
    transform: "translate(4.971)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_446",
    "data-name": "Path 446",
    d: "M184.958,309.576l27.934,16.107v55.028l-27.934-16.063Z",
    transform: "translate(-184.958 -276.888)",
    fill: "#656c9a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_447",
    "data-name": "Path 447",
    d: "M263.978,296.349l-56.894,32.806v55.028l56.894-32.715Z",
    transform: "translate(-179.151 -280.36)",
    fill: "#7d86b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_448",
    "data-name": "Path 448",
    d: "M221.267,310.464l24.4-14.072v2.193l-24.4,14.033Z",
    transform: "translate(-175.428 -280.349)",
    fill: "#34324c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_449",
    "data-name": "Path 449",
    d: "M208.141,330.126l54.281-31.156v6.472l-54.281,31.075Z",
    transform: "translate(-178.873 -279.672)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_450",
    "data-name": "Path 450",
    d: "M207.084,337.5l56.894-32.8v1.724l-56.894,32.723Z",
    transform: "translate(-179.151 -278.169)",
    fill: "#656c9a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_451",
    "data-name": "Path 451",
    d: "M221.267,320.205l24.4-14.072v2.193l-24.4,14.033Z",
    transform: "translate(-175.428 -277.792)",
    fill: "#34324c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_452",
    "data-name": "Path 452",
    d: "M208.141,339.331l54.281-31.156v6.472l-54.281,31.076Z",
    transform: "translate(-178.873 -277.256)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_453",
    "data-name": "Path 453",
    d: "M207.084,346.7l56.894-32.8v1.724l-56.894,32.724Z",
    transform: "translate(-179.151 -275.753)",
    fill: "#656c9a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_454",
    "data-name": "Path 454",
    d: "M221.267,329.41l24.4-14.072v2.193l-24.4,14.033Z",
    transform: "translate(-175.428 -275.375)",
    fill: "#34324c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_455",
    "data-name": "Path 455",
    d: "M208.141,362.464l54.281-31.156v8.34l-54.281,31.076Z",
    transform: "translate(-178.873 -271.184)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_456",
    "data-name": "Path 456",
    d: "M221.267,352.543l24.4-14.072v2.193l-24.4,14.033Z",
    transform: "translate(-175.428 -269.303)",
    fill: "#34324c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_457",
    "data-name": "Path 457",
    d: "M208.141,348.74l54.281-31.156v10.927l-54.281,31.076Z",
    transform: "translate(-178.873 -274.786)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_458",
    "data-name": "Path 458",
    d: "M221.267,338.82l24.4-14.072v2.193l-24.4,14.033Z",
    transform: "translate(-175.428 -272.906)",
    fill: "#34324c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_459",
    "data-name": "Path 459",
    d: "M207.084,360.346l56.894-32.8v1.724l-56.894,32.724Z",
    transform: "translate(-179.151 -272.172)",
    fill: "#656c9a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_460",
    "data-name": "Path 460",
    d: "M269.786,299.674l-56.894,32.806-27.934-16.107,56.936-32.688Z",
    transform: "translate(-184.958 -283.684)",
    fill: "#a6acc6"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_461",
    "data-name": "Path 461",
    d: "M207.084,372.862l57.862-33.335v1.736L207.084,374.6Z",
    transform: "translate(-174.18 -269.026)",
    fill: "#dfc4b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_462",
    "data-name": "Path 462",
    d: "M207.084,371.888l56.894-32.8.968.559-57.862,33.362Z",
    transform: "translate(-174.18 -269.142)",
    fill: "#efd9d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_463",
    "data-name": "Path 463",
    d: "M213.093,369.392l-28.9-16.646v1.736l28.9,16.646Z",
    transform: "translate(-180.189 -265.556)",
    fill: "#ceafa3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_464",
    "data-name": "Path 464",
    d: "M186.089,312.274l24.416,14.062v2.843l-24.416-14.062Z",
    transform: "translate(-179.691 -276.18)",
    fill: "#dfc4b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_465",
    "data-name": "Path 465",
    d: "M213.093,368.418,185.16,352.3l-.968.559,28.9,16.674Z",
    transform: "translate(-180.189 -265.672)",
    fill: "#efd9d0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11851",
    "data-name": "Group 11851",
    transform: "translate(7.855 37.825)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_466",
    "data-name": "Path 466",
    d: "M203.9,323.873a1.15,1.15,0,0,0,.478.917c.265.153.48-.01.48-.362a1.148,1.148,0,0,0-.48-.917C204.117,323.358,203.9,323.521,203.9,323.873Z",
    transform: "translate(-182.87 -311.07)",
    fill: "#34324c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_467",
    "data-name": "Path 467",
    d: "M187.243,314.064a1.148,1.148,0,0,0,.48.917c.265.153.48-.009.48-.362a1.148,1.148,0,0,0-.48-.917C187.458,313.549,187.243,313.712,187.243,314.064Z",
    transform: "translate(-187.243 -313.645)",
    fill: "#34324c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11853",
    "data-name": "Group 11853",
    transform: "translate(21.129 33.118)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_468",
    "data-name": "Path 468",
    d: "M215.119,305.074c-.042-.024-4.209-2.53-9.226-5.032a3.981,3.981,0,0,0-3.46-.265,5.753,5.753,0,0,0-2.522,2.265c-.59.337-1.55.89-2.153,1.28.616-1.374,1.968-3.781,4.184-4.709a5.241,5.241,0,0,1,4.515.3c5.065,2.525,9.273,5.055,9.315,5.081Z",
    transform: "translate(-197.757 -298.234)",
    fill: "#23203a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11859",
    "data-name": "Group 11859",
    transform: "translate(28.243)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11854",
    "data-name": "Group 11854"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_469",
    "data-name": "Path 469",
    d: "M228.128,293.671,204.355,307.4c-.53.307-.963-.021-.963-.727V287.682a2.315,2.315,0,0,1,.963-1.841l23.773-13.726c.53-.306.963.023.963.728v18.988A2.313,2.313,0,0,1,228.128,293.671Z",
    transform: "translate(-203.392 -272.001)",
    fill: "#23203a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_470",
    "data-name": "Path 470",
    d: "M203.674,300.24l1.261.715-.105-1.452Z",
    transform: "translate(-203.318 -264.783)",
    fill: "#23203a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_471",
    "data-name": "Path 471",
    d: "M224.861,272.783l-1.288-.732-.457,2.529Z",
    transform: "translate(-198.215 -271.988)",
    fill: "#23203a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_472",
    "data-name": "Path 472",
    d: "M229.16,294.258l-23.773,13.726c-.53.306-.963-.023-.963-.728V288.268a2.313,2.313,0,0,1,.963-1.839L229.16,272.7c.53-.305.963.022.963.729v18.986A2.313,2.313,0,0,1,229.16,294.258Z",
    transform: "translate(-203.121 -271.847)",
    fill: "#34324c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_473",
    "data-name": "Path 473",
    d: "M229.117,291.859l-24.034,13.876V287.351l24.034-13.876Z",
    transform: "translate(-202.948 -271.615)",
    fill: "#23203a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_474",
    "data-name": "Path 474",
    d: "M216.51,294.114l-3.06,1.766c-.158.092-.288-.006-.288-.217h0a.692.692,0,0,1,.288-.55l3.06-1.766c.158-.092.288.006.288.217h0A.7.7,0,0,1,216.51,294.114Z",
    transform: "translate(-200.828 -266.408)",
    fill: "#dfc4b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_475",
    "data-name": "Path 475",
    d: "M227.6,292.1l-21.552,12.443V287.787L227.6,275.344Z",
    transform: "translate(-202.695 -271.124)",
    fill: "#dfc4b7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11855",
    "data-name": "Group 11855",
    transform: "translate(2.246 23.015)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_476",
    "data-name": "Path 476",
    d: "M248.678,303.241,225.717,316.5a2.675,2.675,0,0,1-2.4-.1l-17.559-10.137c-.708-.409-.785-1.033-.173-1.387l22.961-13.256a2.683,2.683,0,0,1,2.4.1L248.5,301.855C249.213,302.264,249.29,302.888,248.678,303.241Z",
    transform: "translate(-205.171 -289.93)",
    fill: "#23203a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24",
    "data-name": "Rectangle 24",
    width: 1.576,
    height: 1.576,
    transform: "translate(0.003 14.013)",
    fill: "#23203a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25",
    "data-name": "Rectangle 25",
    width: 1.576,
    height: 1.577,
    transform: "translate(42.343 11.209)",
    fill: "#23203a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_477",
    "data-name": "Path 477",
    d: "M248.678,302.093l-22.961,13.256a2.679,2.679,0,0,1-2.4-.1l-17.559-10.136c-.708-.409-.785-1.034-.173-1.387l22.961-13.256a2.679,2.679,0,0,1,2.4.1L248.5,300.707C249.213,301.116,249.29,301.74,248.678,302.093Z",
    transform: "translate(-205.171 -290.231)",
    fill: "#34324c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_478",
    "data-name": "Path 478",
    d: "M241.035,297.766,218.281,310.9l-11.546-6.666L229.489,291.1Z",
    transform: "translate(-204.76 -290.003)",
    fill: "#23203a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_479",
    "data-name": "Path 479",
    d: "M235.462,303.071l-8.051,4.649-4.308-2.487,8.052-4.649Z",
    transform: "translate(-200.464 -287.514)",
    fill: "#23203a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_480",
    "data-name": "Path 480",
    d: "M207.523,301.675l1.588-.917,1.142.659-1.588.917Z",
    transform: "translate(-204.553 -287.468)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_481",
    "data-name": "Path 481",
    d: "M208.838,302.434l1.588-.917,1.142.659-1.588.917Z",
    transform: "translate(-204.208 -287.268)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_482",
    "data-name": "Path 482",
    d: "M210.153,303.26l2.144-1.238,1.142.659L211.3,303.92Z",
    transform: "translate(-203.863 -287.136)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_483",
    "data-name": "Path 483",
    d: "M226.419,293.736l1.036-.6,2.8,1.618-1.036.6Z",
    transform: "translate(-199.593 -289.468)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_484",
    "data-name": "Path 484",
    d: "M211.468,304.019l2.144-1.237,1.142.659-2.144,1.238Z",
    transform: "translate(-203.518 -286.937)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_485",
    "data-name": "Path 485",
    d: "M212.783,304.862l2.834-1.636,1.142.659-2.834,1.637Z",
    transform: "translate(-203.173 -286.82)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_486",
    "data-name": "Path 486",
    d: "M226.544,297.085l4.232-2.443,1.142.659-4.232,2.443Z",
    transform: "translate(-199.561 -289.073)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_487",
    "data-name": "Path 487",
    d: "M214.1,305.471l1.588-.917,1.142.66-1.588.917Z",
    transform: "translate(-202.827 -286.471)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_488",
    "data-name": "Path 488",
    d: "M209.1,300.767l1.588-.917,1.142.659-1.588.917Z",
    transform: "translate(-204.14 -287.706)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_489",
    "data-name": "Path 489",
    d: "M210.411,301.526l1.588-.917,1.142.66-1.588.917Z",
    transform: "translate(-203.795 -287.507)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_490",
    "data-name": "Path 490",
    d: "M210.686,299.849l1.588-.917,1.142.66-1.588.917Z",
    transform: "translate(-203.723 -287.947)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_491",
    "data-name": "Path 491",
    d: "M212,300.609l1.588-.917,1.142.659-1.588.917Z",
    transform: "translate(-203.378 -287.748)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_492",
    "data-name": "Path 492",
    d: "M212.259,298.941l1.588-.917,1.142.66-1.588.917Z",
    transform: "translate(-203.31 -288.185)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_493",
    "data-name": "Path 493",
    d: "M213.574,299.7l1.588-.917,1.142.659-1.588.917Z",
    transform: "translate(-202.965 -287.986)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_494",
    "data-name": "Path 494",
    d: "M213.844,298.026l1.588-.917,1.142.659-1.588.917Z",
    transform: "translate(-202.894 -288.426)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_495",
    "data-name": "Path 495",
    d: "M215.159,298.785l1.588-.917,1.142.66-1.588.917Z",
    transform: "translate(-202.549 -288.226)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_496",
    "data-name": "Path 496",
    d: "M215.417,297.118l1.588-.917,1.142.659-1.588.917Z",
    transform: "translate(-202.481 -288.664)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497",
    "data-name": "Path 497",
    d: "M216.732,297.877l1.588-.917,1.142.659-1.588.917Z",
    transform: "translate(-202.136 -288.465)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_498",
    "data-name": "Path 498",
    d: "M217.006,296.2l1.588-.917,1.142.659-1.588.917Z",
    transform: "translate(-202.064 -288.905)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_499",
    "data-name": "Path 499",
    d: "M218.321,296.959l1.588-.917,1.142.66-1.588.917Z",
    transform: "translate(-201.719 -288.706)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_500",
    "data-name": "Path 500",
    d: "M212.207,302.008l1.588-.917,1.142.659-1.588.917Z",
    transform: "translate(-203.324 -287.381)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_501",
    "data-name": "Path 501",
    d: "M213.522,302.767l1.588-.917,1.142.66-1.588.917Z",
    transform: "translate(-202.979 -287.181)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_502",
    "data-name": "Path 502",
    d: "M213.8,301.09l1.588-.917,1.142.659-1.588.917Z",
    transform: "translate(-202.907 -287.621)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_503",
    "data-name": "Path 503",
    d: "M215.112,301.849l1.588-.917,1.142.659-1.588.917Z",
    transform: "translate(-202.561 -287.422)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_504",
    "data-name": "Path 504",
    d: "M215.37,300.182l1.588-.917,1.142.659-1.588.917Z",
    transform: "translate(-202.494 -287.86)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_505",
    "data-name": "Path 505",
    d: "M216.685,300.941l1.588-.917,1.142.659-1.588.917Z",
    transform: "translate(-202.149 -287.66)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_506",
    "data-name": "Path 506",
    d: "M216.955,299.267l1.588-.917,1.142.66-1.588.917Z",
    transform: "translate(-202.078 -288.1)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_507",
    "data-name": "Path 507",
    d: "M218.27,300.026l1.588-.917,1.142.66-1.588.917Z",
    transform: "translate(-201.732 -287.901)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_508",
    "data-name": "Path 508",
    d: "M218.528,298.359l1.588-.917,1.142.659-1.588.917Z",
    transform: "translate(-201.665 -288.338)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509",
    "data-name": "Path 509",
    d: "M219.843,299.118l1.588-.917,1.142.66-1.588.917Z",
    transform: "translate(-201.32 -288.139)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510",
    "data-name": "Path 510",
    d: "M220.117,297.441l1.588-.917,1.142.659-1.588.917Z",
    transform: "translate(-201.248 -288.579)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_511",
    "data-name": "Path 511",
    d: "M221.432,298.2l1.588-.917,1.142.659-1.588.917Z",
    transform: "translate(-200.902 -288.38)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_512",
    "data-name": "Path 512",
    d: "M221.7,296.529l1.588-.917,1.142.659-1.588.917Z",
    transform: "translate(-200.833 -288.818)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_513",
    "data-name": "Path 513",
    d: "M223.011,297.289l1.588-.917,1.142.659-1.588.917Z",
    transform: "translate(-200.488 -288.619)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_514",
    "data-name": "Path 514",
    d: "M215.463,303.165l1.588-.917,1.142.659-1.588.917Z",
    transform: "translate(-202.469 -287.077)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_515",
    "data-name": "Path 515",
    d: "M217.052,302.247l1.588-.917,1.142.659-1.588.917Z",
    transform: "translate(-202.052 -287.318)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_516",
    "data-name": "Path 516",
    d: "M218.625,301.339l1.588-.917,1.142.659-1.588.917Z",
    transform: "translate(-201.639 -287.556)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_517",
    "data-name": "Path 517",
    d: "M220.21,300.424l1.588-.917,1.142.66-1.588.917Z",
    transform: "translate(-201.223 -287.796)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_518",
    "data-name": "Path 518",
    d: "M221.783,299.516l1.588-.917,1.142.659-1.588.917Z",
    transform: "translate(-200.81 -288.035)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_519",
    "data-name": "Path 519",
    d: "M223.373,298.6l1.588-.917,1.142.659-1.588.917Z",
    transform: "translate(-200.393 -288.275)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_520",
    "data-name": "Path 520",
    d: "M224.951,297.687l1.588-.917,1.142.659-1.588.917Z",
    transform: "translate(-199.979 -288.515)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_521",
    "data-name": "Path 521",
    d: "M223.285,295.612l1.588-.917,1.142.66-1.588.917Z",
    transform: "translate(-200.416 -289.059)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_522",
    "data-name": "Path 522",
    d: "M224.6,296.371l1.588-.917,1.142.66-1.588.917Z",
    transform: "translate(-200.071 -288.86)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_523",
    "data-name": "Path 523",
    d: "M224.858,294.7l1.588-.917,1.142.66-1.588.917Z",
    transform: "translate(-200.003 -289.298)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_524",
    "data-name": "Path 524",
    d: "M226.173,295.463l1.588-.917,1.142.66-1.588.917Z",
    transform: "translate(-199.658 -289.098)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_525",
    "data-name": "Path 525",
    d: "M218.579,295.292l1.588-.917,1.142.66-1.588.917Z",
    transform: "translate(-201.651 -289.143)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_526",
    "data-name": "Path 526",
    d: "M219.894,296.051l1.588-.917,1.142.659-1.588.917Z",
    transform: "translate(-201.306 -288.944)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_527",
    "data-name": "Path 527",
    d: "M220.189,294.363l1.588-.917,1.142.659-1.588.917Z",
    transform: "translate(-201.229 -289.387)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_528",
    "data-name": "Path 528",
    d: "M221.5,295.122l1.588-.917,1.142.66-1.588.917Z",
    transform: "translate(-200.884 -289.188)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_529",
    "data-name": "Path 529",
    d: "M221.762,293.454l1.588-.917,1.142.659-1.588.917Z",
    transform: "translate(-200.816 -289.626)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_530",
    "data-name": "Path 530",
    d: "M223.077,294.214l1.588-.917,1.142.66-1.588.917Z",
    transform: "translate(-200.471 -289.426)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_531",
    "data-name": "Path 531",
    d: "M223.351,292.537l1.588-.917,1.142.659-1.588.917Z",
    transform: "translate(-200.399 -289.866)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_532",
    "data-name": "Path 532",
    d: "M224.666,293.3l1.588-.917,1.142.659-1.588.917Z",
    transform: "translate(-200.054 -289.667)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_533",
    "data-name": "Path 533",
    d: "M215.671,304.563l1.588-.917,1.142.66-1.588.917Z",
    transform: "translate(-202.414 -286.71)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_534",
    "data-name": "Path 534",
    d: "M217.261,303.645l1.588-.917,1.142.659-1.588.917Z",
    transform: "translate(-201.997 -286.951)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_535",
    "data-name": "Path 535",
    d: "M225.535,298.887l1.588-.917,1.142.66-1.588.917Z",
    transform: "translate(-199.825 -288.2)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_536",
    "data-name": "Path 536",
    d: "M227.108,297.978l1.588-.917,1.142.66-1.588.917Z",
    transform: "translate(-199.412 -288.438)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_537",
    "data-name": "Path 537",
    d: "M228.7,297.231l3.1-1.733,1.142.659-3.1,1.733Z",
    transform: "translate(-198.995 -288.849)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_538",
    "data-name": "Path 538",
    d: "M218.85,303.5l8.018-4.629,1.142.659-8.018,4.629Z",
    transform: "translate(-201.58 -287.963)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_539",
    "data-name": "Path 539",
    d: "M208.653,304.8l-2.259-1.3v-.727l2.259,1.3Z",
    transform: "translate(-202.604 -263.926)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_540",
    "data-name": "Path 540",
    d: "M210.723,305.994l-2.259-1.3v-.727l2.259,1.3Z",
    transform: "translate(-202.061 -263.612)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11856",
    "data-name": "Group 11856",
    transform: "translate(5.089 9.394)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_541",
    "data-name": "Path 541",
    d: "M226.179,279.442l-18.756,10.829v.735l18.756-10.829Z",
    transform: "translate(-207.423 -279.442)",
    fill: "#ea6f53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11857",
    "data-name": "Group 11857",
    transform: "translate(5.089 13.32)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_542",
    "data-name": "Path 542",
    d: "M226.179,282.552l-18.756,10.829v.735l18.756-10.829Z",
    transform: "translate(-207.423 -282.552)",
    fill: "#ea6f53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11858",
    "data-name": "Group 11858",
    transform: "translate(5.089 17.373)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_543",
    "data-name": "Path 543",
    d: "M226.179,285.762l-18.756,10.829v.735L226.179,286.5Z",
    transform: "translate(-207.423 -285.762)",
    fill: "#ea6f53"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_544",
    "data-name": "Path 544",
    d: "M208.122,298.933l-.659.38V286.142l.659-.38Z",
    transform: "translate(-202.323 -268.389)",
    fill: "#34324c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11871",
    "data-name": "Group 11871",
    transform: "translate(267.066 342.331)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11869",
    "data-name": "Group 11869"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_545",
    "data-name": "Path 545",
    d: "M231.318,354.857c1.309-.819,7.935,3.041,7.935,3.041l9.147,3.069-.7,6.889a5.9,5.9,0,0,1-7.759.442c-2.688-1.81-7.4-4.63-8.9-7.707S230.009,355.675,231.318,354.857Z",
    transform: "translate(-216.752 -258.923)",
    fill: "#34324c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_546",
    "data-name": "Path 546",
    d: "M241.872,336.841c1.722-5.666,3.1-7.957,6.754-9.422,2.155-.864,7.151-.177,12.311.941.655,4.642.029,9.883-2.467,13.863-1.751-.946-3.484-1.89-5.114-2.784a30.991,30.991,0,0,0-1.759,6.208,121.12,121.12,0,0,0-1.832,12.763c-.177,3.669-.518,9.1-.518,9.1a8.984,8.984,0,0,1-8.587,1.323c-4.7-1.839-3.7-6.037-3.7-6.037S240.635,340.916,241.872,336.841Z",
    transform: "translate(-214.975 -266.197)",
    fill: "#23203a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_547",
    "data-name": "Path 547",
    d: "M275.547,305.417s3.916,7.105,3.434,12.355-9.281,9.88-9.281,9.88l-5.306-16.881Z",
    transform: "translate(-207.752 -271.87)",
    fill: "#ffc5b3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11868",
    "data-name": "Group 11868",
    transform: "translate(25.318 72.988)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_548",
    "data-name": "Path 548",
    d: "M258.985,346.747a3.05,3.05,0,0,1,3.041,3.041v28.059a3.041,3.041,0,0,1-6.081,0V349.788A3.05,3.05,0,0,1,258.985,346.747Z",
    transform: "translate(-235.287 -334.01)",
    fill: "#34324c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11861",
    "data-name": "Group 11861",
    transform: "translate(4.462)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_549",
    "data-name": "Path 549",
    d: "M262.353,342.116c10.625,0,19.238,4.58,19.238,10.232s-8.613,10.232-19.238,10.232S243.116,358,243.116,352.348,251.729,342.116,262.353,342.116Z",
    transform: "translate(-243.116 -335.225)",
    fill: "#dfc4b7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26",
    "data-name": "Rectangle 26",
    width: 38.474,
    height: 2.227,
    transform: "translate(0 15.193)",
    fill: "#dfc4b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_550",
    "data-name": "Path 550",
    d: "M262.353,340.587c10.625,0,19.238,4.58,19.238,10.232s-8.613,10.232-19.238,10.232-19.236-4.582-19.236-10.232S251.729,340.587,262.353,340.587Z",
    transform: "translate(-243.116 -335.627)",
    fill: "#efd9d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_551",
    "data-name": "Path 551",
    d: "M262.164,340.09c10.123,0,18.329,4.364,18.329,9.749s-8.206,9.75-18.329,9.75-18.328-4.366-18.328-9.75S252.042,340.09,262.164,340.09Z",
    transform: "translate(-242.927 -335.757)",
    fill: "#d6543e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_552",
    "data-name": "Path 552",
    d: "M279.521,342.852l.972,6.263H243.836l.974-6.263Z",
    transform: "translate(-242.927 -335.032)",
    fill: "#d6543e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_553",
    "data-name": "Path 553",
    d: "M262.014,336.658c9.726,0,17.609,4.194,17.609,9.366s-7.883,9.368-17.609,9.368-17.608-4.194-17.608-9.368S252.289,336.658,262.014,336.658Z",
    transform: "translate(-242.777 -336.658)",
    fill: "#ea6f53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_554",
    "data-name": "Path 554",
    d: "M262.014,336.658c9.726,0,17.609,4.194,17.609,9.366s-7.883,9.368-17.609,9.368-17.608-4.194-17.608-9.368S252.289,336.658,262.014,336.658Z",
    transform: "translate(-242.777 -336.658)",
    fill: "#ea6f53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11862",
    "data-name": "Group 11862",
    transform: "translate(39.665 59.103)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_555",
    "data-name": "Path 555",
    d: "M275.2,383.78a6.134,6.134,0,0,1,2.56,4.893c0,1.885-1.146,2.752-2.56,1.935a6.133,6.133,0,0,1-2.56-4.892C272.639,383.83,273.785,382.963,275.2,383.78Z",
    transform: "translate(-270.57 -383.473)",
    fill: "#34324c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_556",
    "data-name": "Path 556",
    d: "M277.069,390.724l-2.058,1.186-3.14-7.189,1.976-1.16Z",
    transform: "translate(-270.771 -383.449)",
    fill: "#34324c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_557",
    "data-name": "Path 557",
    d: "M273.56,384.727a6.134,6.134,0,0,1,2.56,4.893c0,1.885-1.146,2.752-2.56,1.935a6.133,6.133,0,0,1-2.56-4.892C271,384.777,272.146,383.91,273.56,384.727Z",
    transform: "translate(-271 -383.224)",
    fill: "#23203a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11863",
    "data-name": "Group 11863",
    transform: "translate(1.338 33.637)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_558",
    "data-name": "Path 558",
    d: "M243.84,363.588l40.456,23.35a2.132,2.132,0,1,1-2.131,3.694L241.709,367.28a2.132,2.132,0,1,1,2.131-3.693Z",
    transform: "translate(-240.642 -363.301)",
    fill: "#34324c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11864",
    "data-name": "Group 11864",
    transform: "translate(1.338 33.637)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_559",
    "data-name": "Path 559",
    d: "M241.709,386.937l40.456-23.35a2.132,2.132,0,1,1,2.131,3.693L243.84,390.631a2.132,2.132,0,1,1-2.131-3.694Z",
    transform: "translate(-240.642 -363.301)",
    fill: "#34324c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11865",
    "data-name": "Group 11865",
    transform: "translate(0 35.734)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_560",
    "data-name": "Path 560",
    d: "M243.782,365.27a6.133,6.133,0,0,1,2.56,4.892c0,1.886-1.146,2.753-2.56,1.937a6.135,6.135,0,0,1-2.562-4.893C241.22,365.32,242.368,364.453,243.782,365.27Z",
    transform: "translate(-239.152 -364.963)",
    fill: "#34324c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_561",
    "data-name": "Path 561",
    d: "M245.651,372.213l-2.058,1.186-3.14-7.189,1.976-1.16Z",
    transform: "translate(-239.353 -364.939)",
    fill: "#34324c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_562",
    "data-name": "Path 562",
    d: "M242.142,366.217a6.133,6.133,0,0,1,2.56,4.892c0,1.886-1.146,2.752-2.56,1.937a6.131,6.131,0,0,1-2.56-4.893C239.582,366.267,240.727,365.4,242.142,366.217Z",
    transform: "translate(-239.582 -364.714)",
    fill: "#23203a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11866",
    "data-name": "Group 11866",
    transform: "translate(2.495 59.701)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_563",
    "data-name": "Path 563",
    d: "M245.757,384.254a6.133,6.133,0,0,1,2.562,4.892c0,1.886-1.148,2.752-2.562,1.937a6.134,6.134,0,0,1-2.56-4.893C243.2,384.3,244.343,383.437,245.757,384.254Z",
    transform: "translate(-241.128 -383.946)",
    fill: "#34324c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_564",
    "data-name": "Path 564",
    d: "M247.628,391.2l-2.058,1.186-3.141-7.189,1.976-1.16Z",
    transform: "translate(-241.329 -383.923)",
    fill: "#34324c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_565",
    "data-name": "Path 565",
    d: "M244.118,385.2a6.132,6.132,0,0,1,2.56,4.892c0,1.886-1.146,2.752-2.56,1.937a6.134,6.134,0,0,1-2.56-4.893C241.558,385.25,242.7,384.384,244.118,385.2Z",
    transform: "translate(-241.558 -383.698)",
    fill: "#23203a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11867",
    "data-name": "Group 11867",
    transform: "translate(41.281 37.065)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_566",
    "data-name": "Path 566",
    d: "M276.481,366.324a6.134,6.134,0,0,1,2.56,4.893c0,1.885-1.146,2.752-2.56,1.935a6.135,6.135,0,0,1-2.562-4.893C273.919,366.374,275.067,365.507,276.481,366.324Z",
    transform: "translate(-271.85 -366.017)",
    fill: "#34324c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_567",
    "data-name": "Path 567",
    d: "M278.35,373.267l-2.058,1.186-3.14-7.189,1.976-1.16Z",
    transform: "translate(-272.051 -365.993)",
    fill: "#34324c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_568",
    "data-name": "Path 568",
    d: "M274.842,367.271a6.134,6.134,0,0,1,2.56,4.892c0,1.886-1.146,2.752-2.56,1.937a6.135,6.135,0,0,1-2.562-4.893C272.28,367.321,273.428,366.454,274.842,367.271Z",
    transform: "translate(-272.28 -365.768)",
    fill: "#23203a"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_569",
    "data-name": "Path 569",
    d: "M223.107,359.768c1.309-.818,7.935,3.041,7.935,3.041l9.147,3.07-.7,6.888a5.9,5.9,0,0,1-7.761.442c-2.687-1.81-7.4-4.63-8.9-7.707S221.8,360.587,223.107,359.768Z",
    transform: "translate(-218.907 -257.634)",
    fill: "#34324c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_570",
    "data-name": "Path 570",
    d: "M276.279,313.263l6.44,10.237s-1.954,2.135-8.177-.976c-7.235-3.618-11.446-4.487-11.446-4.487l1.172-5.462Z",
    transform: "translate(-208.092 -269.991)",
    fill: "#7f0057"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_571",
    "data-name": "Path 571",
    d: "M270.777,315.656c-1.454-2.711-2.77-5.2-2.77-5.2L265.545,298.4s4.146-1.606,7.2,1.024c1.823,1.567,4.6,7.133,6.762,11.782A15.248,15.248,0,0,1,270.777,315.656Z",
    transform: "translate(-207.45 -273.838)",
    fill: "#ceafa3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_572",
    "data-name": "Path 572",
    d: "M260.172,282.2c2.6-1.8,7.593-1.24,9.759,3.338,1.2,2.534-.495,9.35-.764,14.136a11.65,11.65,0,0,0,1.077,6.088l-3.31,1.365a10,10,0,0,1-6.762,0l.107-5.886s-3.564-.53-4.189-1.1c-1.5-1.376-2.3-5.47-1.6-10.753C255.526,281.521,259.215,282.859,260.172,282.2Z",
    transform: "translate(-210.418 -278.216)",
    fill: "#ffc5b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_573",
    "data-name": "Path 573",
    d: "M233.662,341.752c1.722-5.666,3.1-7.956,6.754-9.421,5.285-2.118,27.645,5.089,27.645,5.089l16.112.837s.826,6.542-3.8,9.883-15.641,6.641-23.606,2.467c-3.8-1.992-7.964-4.247-11.626-6.256a30.966,30.966,0,0,0-1.759,6.208,121.019,121.019,0,0,0-1.832,12.762c-.177,3.669-.518,9.1-.518,9.1a8.988,8.988,0,0,1-8.587,1.323c-4.7-1.841-3.7-6.038-3.7-6.038S232.423,345.828,233.662,341.752Z",
    transform: "translate(-217.131 -264.908)",
    fill: "#23203a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_574",
    "data-name": "Path 574",
    d: "M252.191,319.748c-1.954-4.17,2.476-11.74,3.718-14.461s5.22-4.377,5.22-4.377l12.067-1.8s5.278,9.185,5.982,14.664c.491,3.838.1,10.929-.109,20.676-.141,6.588,3.678,10.658.89,13.531-4.236,4.367-13.923,7.4-19.338,5.953-3.238-.867-5.46-4.212-7.633-6.877-2.387-2.928-3.631-9.975-.553-12.874C252.816,334.206,256.183,328.272,252.191,319.748Z",
    transform: "translate(-211.37 -273.524)",
    fill: "#dfc4b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_575",
    "data-name": "Path 575",
    d: "M259.534,299.612s4.823,1.42,7.668-.8c4.026-3.139,4.468,1.278,4.468,1.278a10.564,10.564,0,0,1-5.065,3.44,12.226,12.226,0,0,1-9.716-.767C256.868,300.588,259.534,299.612,259.534,299.612Z",
    transform: "translate(-209.722 -273.899)",
    fill: "#bc978b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_576",
    "data-name": "Path 576",
    d: "M229.1,306.007c1.225-.055.837-2.1,1.365-3.046.641-1.156,1.165-1.25,1.365-.236.487,2.474,1.5,7.8,2.669,8.414a87.326,87.326,0,0,1,12.891,8.569s14.433-15.441,18.132-14.543c1.93.468,2.689,4.555,1.019,8.754-2.136,5.374-16.647,15.861-16.647,15.861-4.6.943-15.895-10.75-18.239-13.245-2.016-2.145-5.943-3.888-7.912-5.4-2.86-2.187-5.012-5.132-3.926-7.808.614-1.514,2.4-.51,4.41.675C225.871,304.977,227.667,306.07,229.1,306.007Z",
    transform: "translate(-219.528 -272.761)",
    fill: "#ffc5b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_577",
    "data-name": "Path 577",
    d: "M252.127,323.258c-4.77-1.458-8.394-5.357-6.246-10.917,4.151-3.986,8.63-8.767,12.98-8.712,2.2.028,3.642,6.127,1.364,10.775C258.815,317.282,255.3,320.577,252.127,323.258Z",
    transform: "translate(-212.777 -272.339)",
    fill: "#ceafa3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_578",
    "data-name": "Path 578",
    d: "M256.931,292.089c-.394-1.318-1.3-4.381-1.521-5.614a6.007,6.007,0,0,1,1.619-5.6c1.958-2.038,8.748-2.693,11.2-1.271s7.68,4.016,5.855,12.483c-1.473,6.845-2.9,7.612-4.973,9.219a11.777,11.777,0,0,1-4.988,1.754,5.882,5.882,0,0,1-2.092-3.875c-.1-.817,0-3.291,0-3.291s1.809-3.58.408-4.856c-1.492-1.36-3.02.8-3.37,1.674-1.223,3.062-.622,8.827-.622,8.827a5.229,5.229,0,0,1-3.616.721c-.991-.249-.119-4.088-.119-4.088S256.635,297.212,256.931,292.089Z",
    transform: "translate(-210.385 -278.845)",
    fill: "#23203a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11870",
    "data-name": "Group 11870",
    transform: "translate(58.097 38.116)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_579",
    "data-name": "Path 579",
    d: "M276.06,313.456l5.488-3.169c5.783-3.338,10.514.239,10.514,7.949v22.023l-26.516,15.309V333.546C265.546,325.835,270.278,316.794,276.06,313.456Z",
    transform: "translate(-265.546 -309.036)",
    fill: "#d6543e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_580",
    "data-name": "Path 580",
    d: "M284.228,315l-.474-5.339,4.493,2.67Z",
    transform: "translate(-260.766 -308.873)",
    fill: "#d6543e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_581",
    "data-name": "Path 581",
    d: "M269.923,349.553l-4.377-2.6,5.178-5.1Z",
    transform: "translate(-265.546 -300.421)",
    fill: "#d6543e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_582",
    "data-name": "Path 582",
    d: "M279.528,315.515l5.487-3.168c5.783-3.339,10.515.237,10.515,7.949v22.022l-26.517,15.31V335.6C269.013,327.895,273.745,318.854,279.528,315.515Z",
    transform: "translate(-264.636 -308.496)",
    fill: "#ea6f53"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_583",
    "data-name": "Path 583",
    d: "M284.579,345.224c-.206-7.253-.025-13.17,0-15.6.031-3.137,3.447-3.284,3.447-.136,0,4.662.463,14.683.391,17-.157,5.036,2.961,20.836-17.109,21.4-2.015.056-10.221-.478-11.669-1.429a34.65,34.65,0,0,0,13.483-3.862C286.155,361.4,284.755,351.441,284.579,345.224Z",
    transform: "translate(-209 -266.153)",
    fill: "#34324c"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthArt);
export default __webpack_public_path__ + "static/media/auth-art.f3df57ae9308798622f9f4862b19c39d.svg";
export { ForwardRef as ReactComponent };